/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from 'react';
import styles from './css/index.module.css';
import './css/chart.css';
import { Offcanvas } from 'react-bootstrap';
import WebViewer from '@pdftron/webviewer';
import Select from 'react-select/creatable';
import { useDispatch, useSelector } from 'react-redux';
import { GetIRLDoc, GetIRLDocData, PostIRLDocuments, setDocs, PostFolderDocuments, DeleteBulkFiles, GetPopulateDownloadBy } from '../../redux/documentsSlice';
import {
    GetDataroomItemInfo,
    PatchWSFolder,
    PostWSFolder,
    setIRLItemsRecieved,
    GetWorkstreams,
    PostWorkstream,
    GetWorkstreamsDefaults,
    GetFolderDefaults,
    PatchWorkstream,
    DeleteWorkstream,
    DeleteWSFolder,
    PostAllWSFolders,
    setJoyRideStepIndex,
    BulkFileDownload,
    setIRLItems,
} from '../../redux/dataroomSlice';
import Analytics from './Analytics';
import KeywordMapper from './KeywordMapper';
import { PostSchedulerObservations } from '../../redux/meetingSlice';
import { GetDocumentUrl } from '../../redux/ndaSlice';
import DocDragDrop from '../CommonComponents/DocDragDrop';
import { format } from 'date-fns';
import { formatDateDifferenc, getExtensionIcon, getFileSize, getYouTubeId, isAudioFile, isValidExtensionToUpload } from '../../utils/commonUtils';
import { toast } from 'react-toastify';
import ReactQuill from 'react-quill';
import { GetGroupMemberPermissions, GetProjectUsers } from '../../redux/teamSlice';
import { FiEdit, FiSearch } from 'react-icons/fi';
import { IoCaretBack, IoCaretForward } from 'react-icons/io5';
import { /*BsChevronDown, BsChevronRight,*/ BsChevronDown, BsChevronRight, BsCloudUpload, BsFolder2, BsThreeDotsVertical } from 'react-icons/bs';
import { AiFillCloseCircle, AiOutlineClose, AiOutlineCloudDownload, AiOutlineEye, AiOutlineInfoCircle, AiOutlineLoading3Quarters, AiOutlinePlus } from 'react-icons/ai';
import { IoIosClose } from 'react-icons/io';
import SearchFilter from './SearchFilter';
import { FileUploader } from 'react-drag-drop-files';
import { useLocation } from 'react-router';
import { RiDatabase2Line, RiDeleteBin6Line } from 'react-icons/ri';
import { IRL_DOC } from '../../apiServices/api_routes';
import axiosInstance from '../../apiServices/axios';
import StreamSaver from 'streamsaver';
import JSZip from 'jszip';
import DoubleConfirmationModal from '../CommonComponents/DoubleConfirmationModal/DoubleConfirmationModal';
import { HiOutlineLightBulb } from 'react-icons/hi';
import { FaRegImages } from 'react-icons/fa';
import { ImageModal } from '../Observations';

const Main = ({ setRunJoyRide, setShowWsModal, showWsModal, addFolderModal, setAddFolderModal }) => {
    const dispatch = useDispatch();
    const { selectedProject } = useSelector(state => state?.projectData);
    const { projectUsersAll } = useSelector(state => state?.team);
    const { user } = useSelector(state => state?.user);
    const { workstreams } = useSelector(state => state?.dataroom);
    const [workstream, setWorkstream] = React.useState();
    useEffect(() => {
        const effectAsync = async () => {
            if (workstream) {
                dispatch(GetIRLDoc(workstream));
                await dispatch(GetDataroomItemInfo(workstream));
                dispatch(GetFolderDefaults(workstreams?.find(item => item?.id === workstream).name));
            }
        };
        effectAsync();
    }, [workstream]);
    useEffect(() => {
        dispatch(GetWorkstreamsDefaults());
        // dispatch(GetFilesSearch({ query: '&searchFields=metadata_storage_path&api-version=2021-04-30-Preview' }));

        if (selectedProject?.id) {
            dispatch(GetProjectUsers(selectedProject?.id));
            dispatch(GetWorkstreams());
        }
    }, [selectedProject]);

    React.useEffect(() => {
        const projectUser = projectUsersAll.find(item => item?.value?.user_id === user?.id);
        projectUser?.value['group_member_id'] && dispatch(GetGroupMemberPermissions(projectUser?.value['group_member_id']));
    }, [projectUsersAll]);

    return (
        <IRL
            workstream={workstream}
            setWorkstream={setWorkstream}
            setRunJoyRide={setRunJoyRide}
            setShowWsModal={setShowWsModal}
            showWsModal={showWsModal}
            addFolderModal={addFolderModal}
            setAddFolderModal={setAddFolderModal}
        />
    );
};
const IRL = ({ workstream, setWorkstream, setRunJoyRide, setShowWsModal, showWsModal, addFolderModal, setAddFolderModal }) => {
    const { data } = useSelector(state => state?.documents);
    const { selectedProject } = useSelector(state => state?.projectData);
    const { user } = useSelector(state => state.user);
    const { items, workstreams } = useSelector(state => state?.dataroom);
    const { selectedUserData, projectUsersAll } = useSelector(state => state?.team);
    const [searchText, setSearchText] = React.useState('');
    const [searchButtonPressed, setSearchButtonPressed] = React.useState(false);
    const [showPDF, setShowPDF] = React.useState(false);
    const [selectedMenuItem, setSelectedMenuItem] = React.useState('analytics');
    const [selectedPDF, setSelectedPDF] = React.useState(null);
    const [selectedFolder, setSelectedFolder] = React.useState();
    const [selectedFileIndex, setSelectedFileIndex] = React.useState();
    const location = useLocation();
    const dispatch = useDispatch();
    const [expandedRows, setExpandedRows] = useState([]);
    const fileInputRef = useRef(null);
    const isProjectAdmin = selectedProject?.vdr?.vdr_admin === user?.id || selectedProject?.project_admins?.some(admin => admin.user_id === user?.id);
    useEffect(() => {
        if (location?.state?.doc) {
            setSelectedPDF(location?.state?.doc);
            setShowPDF(true);
            window.history.pushState(null, '', '/dataroom/pdf-viewer');
        }
    }, [location]);
    React.useEffect(() => {
        if (workstreams?.length > 0) {
            if (localStorage['workstream']) {
                const idFromLocal = workstreams?.find(item => item?.id === parseInt(localStorage['workstream']))?.id;
                if (idFromLocal) setWorkstream(idFromLocal);
                else setWorkstream(workstreams[0]?.id);
            } else {
                setWorkstream(workstreams[0]?.id);
            }
        }
    }, [workstreams]);
    useEffect(() => {
        // Check the initial URL to determine whether to show the PDF viewer
        if (window.location.pathname === '/dataroom/pdf-viewer') {
            setShowPDF(true);
        }

        const handleLocationChange = () => {
            // Check the current URL and update the state accordingly
            if (window.location.pathname === '/dataroom/pdf-viewer') {
                setShowPDF(true);
            } else {
                setShowPDF(false);
            }
        };

        // Add a popstate event listener to handle back button clicks
        window.addEventListener('popstate', handleLocationChange);

        // Clean up the event listener when the component is unmounted
        return () => {
            window.removeEventListener('popstate', handleLocationChange);
        };
    }, []);
    function getParentPermission(parentId, parentType) {
        if (parentId && parentType === 'workstream') {
            const workstream = selectedUserData?.workstreams?.find(ws => ws.workstream_id === parentId);
            if (workstream) {
                return workstream.permission[0] || getParentPermission(workstream.acl_id, 'folder');
            }
        } else if (parentId && parentType === 'folder') {
            for (const workstream of selectedUserData?.workstreams || []) {
                const folder = workstream.folders.find(f => f.folder_id === parentId);
                if (folder) {
                    return folder.permission[0] || getParentPermission(folder.acl_id, 'workstream');
                }
            }
        }
        return null;
    }
    function checkPermission(type, id, kind, parentId) {
        let permissions = null;
        if (type === 'workstream') {
            const workstream = selectedUserData?.workstreams?.find(ws => ws.workstream_id === id);
            if (workstream) {
                permissions = workstream.permission[0] || getParentPermission(workstream.acl_id, 'folder');
            }
        } else if (type === 'folder') {
            for (const workstream of selectedUserData?.workstreams || []) {
                const folder = workstream.folders.find(f => f.folder_id === id);
                if (folder) {
                    permissions = folder.permission[0] || getParentPermission(parentId, 'workstream');
                    break;
                }
            }
        } else if (type === 'file') {
            for (const workstream of selectedUserData?.workstreams || []) {
                const folder = workstream.folders.find(f => f.folder_id === parentId);
                if (folder) {
                    const file = folder.files.find(f => f.file_id === id);
                    if (file) {
                        permissions = file.permission[0] || getParentPermission(parentId, 'folder');
                        break;
                    }
                }
            }
        }
        if (permissions) {
            return permissions[kind] === true;
        }
        return false;
    }
    // Upload bulk folders code commented here
    const handleButtonClick = () => {
        fileInputRef.current.click();
    };
    const handleBulkFolderUpload = async folderStructure => {
        let allRequestsSucceeded = true;

        try {
            const formData = new FormData();

            for (const [folderPath, files] of Object.entries(folderStructure)) {
                for (const file of files) {
                    formData.append('document', file);
                    formData.append('path', folderPath); // Assuming backend handles paths
                    formData.append('document_name', file.name);
                    formData.append('project', selectedProject?.id);
                    formData.append('vdr', selectedProject?.vdr?.id);
                }
            }
            console.log(formData);
            let res = await dispatch(PostFolderDocuments({ body: formData, ws_id: workstream }));
            if (res?.type === 'POST_IRL_DOC/rejected') {
                allRequestsSucceeded = false;
            } else {
                let folders = res?.payload.map(item => {
                    return {
                        name: item?.ws_folder,
                        id: item?.ws_folder_id,
                        parent: item?.parent_folder_id,
                        ws_id: res?.meta?.arg?.ws_id,
                        ws_name: item?.workstream,
                        prefix: item?.ws_folder_prefix,
                    };
                });
                console.log(folders);
                function transformFolders(flatFolders) {
                    const foldersMap = new Map();
                    const nestedFolders = [];

                    // Create a map for quick access to folders by ID and remove duplicates
                    const uniqueFolders = flatFolders.reduce((acc, folder) => {
                        if (!foldersMap.has(folder?.id)) {
                            const folderCopy = { ...folder, children: [] };
                            foldersMap.set(folder?.id, folderCopy);
                            acc.push(folderCopy);
                        }
                        return acc;
                    }, []);

                    // Build the hierarchy by iterating through each folder
                    uniqueFolders.forEach(folder => {
                        const currentFolder = foldersMap.get(folder?.id);

                        if (folder?.parent === null) {
                            // Top-level folder
                            nestedFolders.push(currentFolder);
                        } else {
                            // Child folder, add it to its parent's children array
                            const parentFolder = foldersMap.get(folder.parent);
                            if (parentFolder) {
                                parentFolder.children.push(currentFolder);
                            }
                        }
                    });

                    return nestedFolders;
                }
                const nestedFolders = transformFolders(folders);
                dispatch(setIRLItems([...items, ...nestedFolders]));
            }
        } catch (error) {
            allRequestsSucceeded = false;
        }
        return allRequestsSucceeded;
    };
    const handleFolderSelection = event => {
        const files = event.target.files;
        const folderStructure = {};
        const promiseToast = toast.loading('Uploading...', { closeButton: true });
        // Iterate over all selected files
        for (let i = 0; i < files.length; i++) {
            const file = files[i];
            // Skip dot files
            if (file.name.startsWith('.')) {
                continue;
            }
            const fullPath = file.webkitRelativePath; // Get the full path of the file
            const folderPath = fullPath.substring(0, fullPath.lastIndexOf('/')); // Extract the folder path

            if (!folderStructure[folderPath]) {
                folderStructure[folderPath] = [];
            }
            folderStructure[folderPath].push(file);
        }
        handleBulkFolderUpload(folderStructure).then(success => {
            if (success) {
                toast.update(promiseToast, {
                    render: 'Folder uploaded successfully',
                    type: 'success',
                    isLoading: false,
                    autoClose: 1000,
                });
            } else {
                toast.update(promiseToast, {
                    render: 'Error in uploading folder',
                    type: 'error',
                    isLoading: false,
                    autoClose: 1000,
                });
            }
        });
    };
    const RenderFolders = ({ folder, data, user, selectedFolder, setSelectedFolder, setSelectedMenuItem, dispatch, level = 0 }) => {
        const isExpanded = expandedRows.includes(folder.id);
        const toggleExpand = () => {
            setExpandedRows(prevRows => {
                if (isExpanded) {
                    return prevRows.filter(id => id !== folder.id);
                } else {
                    return [...prevRows, folder.id];
                }
            });
        };
        const [isDragging, setDragging] = React.useState(false);
        let docLength = 0;
        const subfolderIds = getSubfolderIds(folder);
        subfolderIds?.forEach(subFolderId => {
            docLength += data?.filter(doc => doc?.ws_folder_id === subFolderId)?.length;
        });
        const isUnread = data?.filter(doc => doc?.ws_folder_id === folder?.id).find(d => d?.read_by?.includes(user?.id) === false);
        const isRegular = docLength > 0 && data?.filter(doc => doc?.ws_folder_id === folder?.id).find(d => d?.read_by?.includes(user?.id) === true);
        const margin = 30 * level;
        const handleDragEnter = e => {
            e.preventDefault();
            e.stopPropagation();
            setDragging(true);
        };
        function getSubfolderIds(folder) {
            let ids = [folder.id];

            if (folder.children && folder.children.length > 0) {
                folder.children.forEach(child => {
                    ids = ids.concat(getSubfolderIds(child));
                });
            }

            return ids;
        }

        const handleDragLeave = e => {
            e.preventDefault();
            e.stopPropagation();
            setDragging(false);
        };

        const handleDragOver = e => {
            e.preventDefault();
            e.stopPropagation();
        };

        const handleDrop = async (e, folder) => {
            e.preventDefault();
            e.stopPropagation();
            setDragging(false);
            setSelectedFolder(folder);
            const filesArray = Array.from(e.dataTransfer.files).filter(file => {
                const extension = file.name.split('.').pop().toLowerCase();
                return isValidExtensionToUpload(extension);
            });
            const filePromiseToast = toast.loading(`Uploading ${filesArray?.length} documents to ${selectedFolder?.name}`, { closeButton: true });
            const formData = new FormData();
            for (const item of filesArray) {
                formData.append('document', item);
            }
            formData.append('ws_folder', parseInt(folder?.id));
            formData.append('project', selectedProject?.id);
            formData.append('vdr', selectedProject?.vdr?.id);
            if (selectedProject?.vdr?.vdr_admin !== user?.id) {
                formData.append('upload_by', projectUsersAll?.find(item => item?.value?.user_id === user?.id)?.value?.group_member_id);
            }
            try {
                let res = await dispatch(PostIRLDocuments({ body: formData, ws_id: workstream }));
                dispatch(setIRLItemsRecieved({ id: folder?.id, flag: true }));

                if (res?.type === 'POST_IRL_DOC/rejected') {
                    console.log(res);
                    if (res?.payload?.detail) {
                        toast.update(filePromiseToast, {
                            render: res?.payload?.detail,
                            type: 'error',
                            isLoading: false,
                            autoClose: 2000,
                        });
                    } else {
                        toast.update(filePromiseToast, {
                            render: `Uploading  Failed`,
                            type: 'error',
                            isLoading: false,
                            autoClose: 2000,
                        });
                    }
                } else {
                    // If the upload is successful, update the file-specific toast
                    toast.update(filePromiseToast, {
                        render: `Uploaded successfully`,
                        type: 'success',
                        isLoading: false,
                        autoClose: 2000,
                    });
                }
            } catch (uploadError) {
                console.error(`Error uploading`, uploadError);
                toast.update(filePromiseToast, {
                    render: `Error uploading`,
                    type: 'error',
                    isLoading: false, // Make sure to update the loading state in case of an error
                    autoClose: 2000,
                });
            }
        };

        return (
            <>
                <div
                    key={folder?.id}
                    role={'button'}
                    onDragEnter={handleDragEnter}
                    onDragLeave={handleDragLeave}
                    onDragOver={handleDragOver}
                    onDrop={e => handleDrop(e, folder)}
                    onClick={() => {
                        toggleExpand();
                        setSelectedFolder(folder);
                        setSelectedMenuItem('files');
                        setTimeout(() => {
                            dispatch(setJoyRideStepIndex(8));
                        }, 300);
                        // selectedMenuItem !== 'files' && userType === 'Consultant' && setSelectedMenuItem('analytics');
                    }}
                    style={{ background: selectedFolder?.id === folder?.id && 'rgba(130, 154, 177, 0.2)', paddingLeft: margin !== 0 && `${margin}px` }}
                    className={(isDragging && styles?.draggingFolder) + ' ' + styles.leftSideRow + ' select-folder-step'}>
                    <div>
                        {folder?.children?.length > 0 && (isExpanded ? <BsChevronDown /> : <BsChevronRight />)}
                        <BsFolder2 color="#829ab1" className="ms-1" />
                        <span
                            style={{
                                color: docLength === 0 && '#829ab1',
                                fontWeight: docLength > 0 && isUnread && 'bold',
                            }}
                            className={styles.smallFont + ' ms-2 '}>
                            {folder?.prefix + ' - '} {folder?.name}
                        </span>
                    </div>
                    <div className={styles.rowCount + ' ' + (docLength > 0 && isUnread && styles.selectedRowCount) + ' ' + (isRegular && !isUnread && styles.regularCount)}>
                        {docLength}
                    </div>
                </div>
                {isExpanded &&
                    folder?.children?.map(child => (
                        <RenderFolders
                            key={child?.id}
                            folder={child}
                            data={data}
                            user={user}
                            selectedFolder={selectedFolder}
                            setSelectedFolder={setSelectedFolder}
                            setSelectedMenuItem={setSelectedMenuItem}
                            dispatch={dispatch}
                            level={level + 1} // Increase the nesting level
                        />
                    ))}
            </>
        );
    };
    const folderFiles = data
        ?.filter(doc => doc?.ws_folder_id === selectedFolder?.id) // Filter items based on selected folder
        .sort((a, b) => a?.item_num - b?.item_num);
    return !showPDF ? (
        <div className="">
            <div className={styles.headerDiv}>
                <div className="">
                    <div className="d-flex align-items-center mb-2">
                        <h3 className={styles.title}>Dataroom</h3>
                        <div
                            className={styles.tourText + ' d-flex align-items-center ms-4 view-tour'}
                            onClick={() => {
                                dispatch(setJoyRideStepIndex(0));
                                setRunJoyRide(true);
                            }}>
                            <HiOutlineLightBulb size={15} />
                            &nbsp; View Tour
                        </div>
                    </div>
                    <h3 className={styles.subTitle}>Select or add a new Workstream to Add Folders and Files to your Project</h3>
                </div>
                <div>
                    <div className="input-group " style={{ width: 270 }}>
                        <input
                            type="text"
                            className={'form-control  ' + styles.headerSearchInput}
                            placeholder="Search"
                            aria-label="Search"
                            aria-describedby="basic-addon2"
                            onChange={e => setSearchText(e.target.value)}
                            onKeyDown={event => {
                                if (event.keyCode === 13) {
                                    setSelectedMenuItem('search');
                                    setSearchButtonPressed(!searchButtonPressed);
                                    setSelectedFolder();
                                }
                            }}
                            value={searchText}
                        />
                        <div className="input-group-append">
                            <div
                                onClick={() => {
                                    setSelectedMenuItem('search');
                                    setSearchButtonPressed(!searchButtonPressed);
                                    setSelectedFolder();
                                }}
                                className={styles.headerSearchIcon}
                                type="button">
                                <FiSearch color={'white'} size={13} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className={styles.wsChipsBody}>
                {isProjectAdmin && (
                    <div
                        onClick={async () => {
                            await setShowWsModal(true);
                            setTimeout(() => {
                                dispatch(setJoyRideStepIndex(2));
                            }, 300);
                        }}
                        style={{ float: 'right' }}
                        className={styles.addWorkstreamChip + ' add-workstream-step'}>
                        <AiOutlinePlus /> &nbsp; Add New Workstream
                    </div>
                )}
                {workstreams?.map(item => (
                    <div
                        key={item?.id}
                        onClick={e => {
                            setWorkstream(item?.id);
                            localStorage.setItem('workstream', item?.id);
                            setSelectedFolder();
                            setSelectedMenuItem('analytics');
                        }}
                        className={(workstream === item?.id && styles.selectedWsChip) + ' workstream-chip-step ' + styles.defaultWSChip}>
                        <span>{item?.name}</span>
                        {isProjectAdmin && (
                            <div className={styles?.dropdown}>
                                <BsThreeDotsVertical />
                                <div className={styles.hoverMenuContent}>
                                    <div
                                        style={{
                                            width: '224px',
                                            top: 20,
                                        }}
                                        className={styles.hoverMenuCont}>
                                        <EditWorkstreamModal selected={item} />
                                        <hr className="mt-2 mb-2" />

                                        <DoubleConfirmationModal
                                            handleAction={() => dispatch(DeleteWorkstream(item?.id))}
                                            message={
                                                'Deleting a Workstream will result in the simultaneous removal of ALL related Folders and Files contained within the Workstream, alongside the user permissions associated with them.'
                                            }>
                                            {/* onClick={() => } */}
                                            <div className={styles.wsChipMenuItem} style={{ color: 'var(--Brand-Secondary)' }}>
                                                <RiDeleteBin6Line className="me-2" />
                                                Delete Workstream
                                            </div>
                                        </DoubleConfirmationModal>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                ))}
            </div>
            {items?.length > 0 ? (
                <div className="row">
                    <div className="col-sm-12 col-md-4 mt-1">
                        <div className="d-flex align-items-center justify-content-between  mb-2">
                            {/* {selectedFolder && (isProjectAdmin || checkPermission('folder', selectedFolder?.id, 'add', selectedFolder?.ws_id)) && (  
                            )} */}
                            <div className="d-flex">
                                <button
                                    onClick={async () => {
                                        setSelectedFolder();
                                        await setAddFolderModal(true);
                                        setTimeout(() => {
                                            dispatch(setJoyRideStepIndex(5));
                                        }, 300);
                                    }}
                                    className="btn btn-primary smallButton add-folder-button-step me-1">
                                    Add Folder &nbsp; <AiOutlinePlus />
                                </button>

                                <div>
                                    <input
                                        type="file"
                                        webkitdirectory="true"
                                        directory="true"
                                        onChange={handleFolderSelection}
                                        style={{ display: 'none' }} // Hide the input element
                                        ref={fileInputRef}
                                    />
                                    <button onClick={handleButtonClick} className="btn btn-primary smallButton ">
                                        Bulk Add Folders &nbsp; <AiOutlinePlus />
                                    </button>
                                </div>
                            </div>

                            <span
                                className={styles.orangeLink}
                                onClick={() => {
                                    setSelectedMenuItem('analytics');
                                    setSelectedFolder();
                                }}>
                                Workstream Analytics
                            </span>
                        </div>
                        <div className={styles.leftSideBody}>
                            {items?.map(item => {
                                if (!item?.parent) {
                                    // if (item?.requested) {
                                    return (
                                        <RenderFolders
                                            key={item?.id}
                                            folder={item}
                                            data={data}
                                            user={user}
                                            selectedFolder={selectedFolder}
                                            setSelectedFolder={setSelectedFolder}
                                            setSelectedMenuItem={setSelectedMenuItem}
                                            dispatch={dispatch}
                                        />
                                    );
                                }
                            })}
                        </div>
                    </div>
                    <div className="col-sm-12 col-md-8">
                        <div className="d-flex justify-content-between">
                            <div className="d-flex">
                                {selectedMenuItem === 'search' && (
                                    <div
                                        // onClick={() => setSelectedMenuItem('analytics')}
                                        className={styles.rightSideMenuBtn + ' ' + (selectedMenuItem === 'search' && styles.selectedMenuBtn)}>
                                        Search Results &nbsp;{' '}
                                        <AiFillCloseCircle onClick={() => setSelectedMenuItem('analytics')} color="var(--Brand-Secondary)" size={13} role="button" />{' '}
                                    </div>
                                )}
                                <>
                                    {selectedFolder && (
                                        <div
                                            onClick={() => setSelectedMenuItem('files')}
                                            className={styles.rightSideMenuBtn + ' ' + (selectedMenuItem === 'files' && styles.selectedMenuBtn)}>
                                            {selectedFolder && (
                                                <>
                                                    {selectedFolder?.prefix}
                                                    &nbsp;
                                                    <span style={{ fontWeight: selectedMenuItem === 'files' && 'bold' }}>{selectedFolder?.name || selectedFolder?.ws_folder}</span>
                                                    &nbsp; &nbsp; &nbsp;
                                                    {/*  */}
                                                    {/* {(isProjectAdmin || checkPermission('folder', selectedFolder?.id, 'delete', selectedFolder?.ws_id)) && (

                                                )} */}
                                                    <div className={styles?.dropdown}>
                                                        <BsThreeDotsVertical />
                                                        <div className={styles.hoverMenuContent}>
                                                            <div
                                                                style={{
                                                                    width: '224px',
                                                                    top: 15,
                                                                }}
                                                                className={styles.hoverMenuCont}>
                                                                {isProjectAdmin && (
                                                                    <>
                                                                        <EditCustomFolder
                                                                            workstream={workstream}
                                                                            selectedFolder={selectedFolder}
                                                                            setSelectedFolder={setSelectedFolder}
                                                                        />
                                                                        <hr className="mt-2 mb-2" />
                                                                    </>
                                                                )}

                                                                <DoubleConfirmationModal
                                                                    handleAction={() => {
                                                                        dispatch(DeleteWSFolder(selectedFolder));
                                                                        setSelectedFolder();
                                                                    }}
                                                                    message={'Deleting a Folder will also delete all files in the folder'}>
                                                                    {' '}
                                                                    <div className={styles.wsChipMenuItem} style={{ color: 'var(--Brand-Secondary)' }}>
                                                                        <RiDeleteBin6Line className="me-2" />
                                                                        Delete Workstream Folder
                                                                    </div>
                                                                </DoubleConfirmationModal>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </>
                                            )}
                                        </div>
                                    )}
                                    <div
                                        onClick={() => setSelectedMenuItem('analytics')}
                                        style={{ fontWeight: selectedMenuItem === 'analytics' && 'bold' }}
                                        className={styles.rightSideMenuBtn + ' ' + (selectedMenuItem === 'analytics' && styles.selectedMenuBtn)}>
                                        {selectedFolder ? 'Folder Analytics' : '`Workstream Analytics'}
                                    </div>
                                    {!selectedFolder && (
                                        <div
                                            onClick={() => setSelectedMenuItem('keyword')}
                                            style={{ fontWeight: selectedMenuItem === 'keyword' && 'bold' }}
                                            className={styles.rightSideMenuBtn + ' ' + (selectedMenuItem === 'keyword' && styles.selectedMenuBtn)}>
                                            Lens Copilot
                                        </div>
                                    )}
                                </>
                            </div>
                            {selectedFolder && (
                                <div style={{ float: 'right' }}>
                                    <AddDocumentModal workstream={workstream} setWorkstream={setWorkstream} selectedFolder={selectedFolder} />
                                </div>
                            )}
                        </div>
                        <div className={styles.rightSideBody}>
                            {selectedMenuItem === 'files' && selectedFolder && (
                                <FilesComponent
                                    workstream={workstream}
                                    setWorkstream={setWorkstream}
                                    setSelectedPDF={setSelectedPDF}
                                    selectedFolder={selectedFolder}
                                    setShowPDF={setShowPDF}
                                    selectedPDF={selectedPDF}
                                    checkPermission={checkPermission}
                                    folderFiles={folderFiles}
                                    setSelectedFileIndex={setSelectedFileIndex}
                                />
                            )}

                            {selectedMenuItem === 'analytics' && (
                                <Analytics workstream={workstream} setSelectedPDF={setSelectedPDF} selectedIRL={selectedFolder} setShowPDF={setShowPDF} />
                            )}
                            {selectedMenuItem === 'keyword' && (
                                <KeywordMapper workstream={workstream} setSelectedPDF={setSelectedPDF} selectedFolder={selectedFolder} setShowPDF={setShowPDF} />
                            )}
                            {selectedMenuItem === 'search' && (
                                <SearchFilter
                                    searchButtonPressed={searchButtonPressed}
                                    searchText={searchText}
                                    setSelectedPDF={setSelectedPDF}
                                    selectedFolder={selectedFolder}
                                    setShowPDF={setShowPDF}
                                    workstream={workstream}
                                />
                            )}
                        </div>
                    </div>
                </div>
            ) : (
                workstreams?.length > 0 &&
                workstream && (
                    <div className={styles.noFolderViewBody}>
                        <div className="text-center">
                            <p>There are no folders or files in this Workstream.</p>
                            <button
                                onClick={async () => {
                                    await setAddFolderModal(true);
                                    setTimeout(() => {
                                        dispatch(setJoyRideStepIndex(5));
                                    }, 300);
                                }}
                                className="btn btn-primary smallButton add-folder-button-step">
                                Add Folders
                            </button>
                            <div>
                                <input
                                    type="file"
                                    webkitdirectory="true"
                                    directory="true"
                                    onChange={handleFolderSelection}
                                    style={{ display: 'none' }} // Hide the input element
                                    ref={fileInputRef}
                                />
                                <button onClick={handleButtonClick} className="btn btn-primary smallButton ">
                                    Bulk Add Folders &nbsp; <AiOutlinePlus />
                                </button>
                            </div>
                        </div>
                    </div>
                )
            )}
            <AddFolderModal showModal={addFolderModal} setShowModal={setAddFolderModal} workstream={workstream} selectedFolder={selectedFolder} />
            <AddWorkstreamModal showModal={showWsModal} setShowModal={setShowWsModal} />
        </div>
    ) : (
        <PDFViewer
            selectedFolder={selectedFolder}
            selectedPDF={selectedPDF}
            setShowPDF={setShowPDF}
            workstream={workstream}
            folderFiles={folderFiles}
            setSelectedFileIndex={setSelectedFileIndex}
            selectedFileIndex={selectedFileIndex}
            setSelectedPDF={setSelectedPDF}
        />
    );
};
const FilesComponent = ({ selectedFolder, setSelectedPDF, setShowPDF, workstream, checkPermission, selectedPDF, folderFiles, setSelectedFileIndex }) => {
    const { data, bulkFilesLoading } = useSelector(state => state?.documents);
    const { selectedProject } = useSelector(state => state?.projectData);
    const [selectedRows, setSelectedRows] = React.useState([]);

    const dispatch = useDispatch();
    const { user } = useSelector(state => state.user);
    const { projectUsersAll } = useSelector(state => state?.team);
    const tableRef = React.useRef(null);
    const handleOpenPDF = async doc => {
        if (doc?.document_link && !doc?.document_link?.includes('youtube')) {
            if (workstream && doc?.id) {
                await dispatch(GetIRLDocData({ id: doc.id, workstream }));
            }
            const { safeOpenUrl } = require('../../utils/urlValidation');
            safeOpenUrl(doc?.document_link, '_blank');
            return null;
        }
        setShowPDF(true);
        setSelectedPDF(doc);
        window.history.pushState(null, '', '/dataroom/pdf-viewer');
    };

    const [dragging, setDragging] = React.useState(false);
    // const handleOpenSheet = async doc => {
    //     const isAlreadyPresent = doc?.read_by?.find(item => item === user?.id);

    //     const { payload, meta } = await dispatch(GetDocumentUrl(doc?.document || doc?.document_link));
    //     if (meta?.requestStatus === 'fulfilled') {
    //         window.open(payload?.data?.image, '_blank').focus();
    //         if (user?.types === 'Consultant' && !isAlreadyPresent) {
    //             dispatch(GetIRLDocData({ id: doc?.id, workstream }));
    //         }
    //     }
    // };
    // const handleCheckSheetExt = ext => {
    //     // eslint-disable-next-line default-case
    //     switch (ext.toLowerCase()) {
    //         case 'xls':
    //         case 'xlsx':
    //         case 'csv':
    //         case 'ods':
    //             return true;
    //     }
    //     return false;
    // };
    const handleSelectAllFilter = val => {
        if (val) {
            let ids = [];
            data?.forEach(doc => {
                if (doc?.ws_folder_id === selectedFolder?.id) ids.push(doc?.id);
            });
            setSelectedRows(ids);
        } else setSelectedRows([]);
    };
    const handleSelectRows = id => {
        if (selectedRows?.find(x => x === id)) {
            setSelectedRows(selectedRows.filter(x => x !== id));
        } else {
            setSelectedRows([...selectedRows, id]);
        }
    };
    const downloadFilesAsZip = async () => {
        console.log(selectedRows);
        let formData = new FormData();
        formData.append('file_ids', JSON.stringify(selectedRows));

        try {
            const response = await dispatch(BulkFileDownload({ id: workstream, body: formData, selectedFolder }));

            if (response?.payload) {
                const blob = new Blob([response.payload.data], { type: 'application/zip' });

                let filename = 'downloaded_file.zip'; // Default filename
                const contentDisposition = response.payload.headers['content-disposition'];
                if (contentDisposition) {
                    const filenameMatch = contentDisposition.match(/filename="?(.+?)"?$/);
                    if (filenameMatch && filenameMatch.length > 1) {
                        filename = filenameMatch[1];
                    }
                }

                // Replace spaces with underscores (or hyphens) in the filename
                const safeFilename = filename.replace(/\s/g, '_');
                // Create and trigger a download link
                const url = window.URL.createObjectURL(blob);
                const downloadLink = document.createElement('a');
                downloadLink.href = url;
                downloadLink.download = filename; // Use the extracted filename
                document.body.appendChild(downloadLink);
                downloadLink.click();
                document.body.removeChild(downloadLink);

                window.URL.revokeObjectURL(url);
            } else {
                console.error('No data received for download');
            }
        } catch (error) {
            console.error('Error while downloading file:', error);
        }
    };

    const handleDeleteBulkFiles = () => {
        dispatch(DeleteBulkFiles({ items: selectedRows, ws_id: workstream }));
    };

    const handleDragEnter = e => {
        e.preventDefault();
        e.stopPropagation();
        setDragging(true);
    };

    const handleDragLeave = e => {
        e.preventDefault();
        e.stopPropagation();
        setDragging(false);
    };

    const handleDragOver = e => {
        e.preventDefault();
        e.stopPropagation();
    };
    const handleDrop = async e => {
        e.preventDefault();
        e.stopPropagation();
        setDragging(false);
        const filesArray = Array.from(e.dataTransfer.files).filter(file => {
            const extension = file.name.split('.').pop().toLowerCase();
            return isValidExtensionToUpload(extension);
        });

        const filePromiseToast = toast.loading(`Uploading ${filesArray?.length} documents to ${selectedFolder?.name}`, { closeButton: true });
        const formData = new FormData();
        for (const item of filesArray) {
            formData.append('document', item);
        }
        formData.append('ws_folder', parseInt(selectedFolder?.id));
        formData.append('project', selectedProject?.id);
        formData.append('vdr', selectedProject?.vdr?.id);
        if (selectedProject?.vdr?.vdr_admin !== user?.id) {
            formData.append('upload_by', projectUsersAll?.find(item => item?.value?.user_id === user?.id)?.value?.group_member_id);
        }
        try {
            let res = await dispatch(PostIRLDocuments({ body: formData, ws_id: workstream }));
            dispatch(setIRLItemsRecieved({ id: selectedFolder?.id, flag: true }));

            if (res?.type === 'POST_IRL_DOC/rejected') {
                console.log(res);
                if (res?.payload?.detail) {
                    toast.update(filePromiseToast, {
                        render: res?.payload?.detail,
                        type: 'error',
                        isLoading: false,
                        autoClose: 2000,
                    });
                } else {
                    toast.update(filePromiseToast, {
                        render: `Uploading  Failed`,
                        type: 'error',
                        isLoading: false,
                        autoClose: 2000,
                    });
                }
            } else {
                // If the upload is successful, update the file-specific toast
                toast.update(filePromiseToast, {
                    render: `Uploaded successfully`,
                    type: 'success',
                    isLoading: false,
                    autoClose: 2000,
                });
            }
        } catch (uploadError) {
            console.error(`Error uploading`, uploadError);
            toast.update(filePromiseToast, {
                render: `Error uploading`,
                type: 'error',
                isLoading: false, // Make sure to update the loading state in case of an error
                autoClose: 2000,
            });
        }
    };

    const handleDeleteFile = id => {
        axiosInstance
            .delete(`${IRL_DOC}${localStorage['project_id']}/${workstream}/${id}/`)
            .then(res => {
                const deleted = data?.find(file => file.id === id);
                console.log(deleted);
                toast.success('Deleted');
                const newList = data?.filter(file => file.id !== id);
                dispatch(setDocs(newList));
                if (deleted) {
                    let check = newList?.find(item => item?.ws_folder_id === deleted?.ws_folder_id);
                    if (!check) {
                        dispatch(
                            setIRLItemsRecieved({
                                id: deleted?.ws_folder_id,
                                flag: false,
                            }),
                        );
                    }
                }
            })
            .catch(err => {
                console.log({ err: err?.response });
                const errorMessage = err?.response?.data?.detail || 'Failed to delete document';
                toast.error(errorMessage);
            });
    };

    React.useEffect(() => {
        setSelectedRows([]);
    }, [selectedFolder, workstream]);
    return (
        <>
            {selectedRows?.length > 0 && (
                <div className={styles.stickyHeader}>
                    <div className={styles.rightHeaderBody}>
                        <button className={'btn btn-primary btn-sm ' + styles.orangeBorderedButton} onClick={downloadFilesAsZip}>
                            Download
                        </button>
                        <DoubleConfirmationModal handleAction={handleDeleteBulkFiles} message="Deleting a File will permanently remove it from the Data Room.">
                            <button className={'btn btn-primary btn-sm ' + styles.orangeBorderedButton}>
                                Delete &nbsp; {bulkFilesLoading && <AiOutlineLoading3Quarters className="rotateLoader" />}
                            </button>
                        </DoubleConfirmationModal>
                    </div>
                </div>
            )}
            <div className={styles.descriptionText}> {selectedFolder?.description}</div>
            <div className={styles.filesBody}>
                <table className={(dragging && styles?.filesTable) + ' w-100'}>
                    <thead className={styles.tableHeader}>
                        <tr>
                            <td style={{ width: 60 }} className="ps-4">
                                <input
                                    type="checkbox"
                                    checked={selectedRows?.length > 0 && selectedRows?.length === data?.filter(d => d?.ws_folder_id === selectedFolder?.id).length ? true : false}
                                    onChange={e => handleSelectAllFilter(e.target.checked)}
                                />
                            </td>
                            <td style={{ width: 80 }} className="">
                                #
                            </td>
                            <td className="">File Name</td>
                            <td className="" style={{ width: 150 }}>
                                Added on
                            </td>
                            <td></td>
                        </tr>
                    </thead>
                    <tbody className={styles.tableBody}>
                        {folderFiles?.map((doc, index) => {
                            // Render JSX for each sorted item
                            let file_data = doc?.document || doc?.document_link;
                            return (
                                <tr key={doc?.id} className={styles.tableRow}>
                                    <td className="ps-4 pt-1">
                                        <input
                                            type={'checkbox'}
                                            className={styles.rowHiddenItem}
                                            style={{ display: selectedRows?.length > 0 && 'block' }}
                                            checked={selectedRows?.find(x => x === doc?.id)}
                                            onChange={e => handleSelectRows(doc?.id, e.target.checked)}
                                        />
                                    </td>
                                    <td className=" pt-1">{selectedFolder?.prefix + '.' + doc?.item_num + ' '}</td>
                                    <td>
                                        <div
                                            role="button"
                                            onClick={() => {
                                                setSelectedFileIndex(index);
                                                handleOpenPDF(doc);
                                            }}
                                            style={{ fontWeight: !doc?.read_by?.includes(user?.id) && user?.types === 'Consultant' && 'bold', height: 32 }}
                                            className="d-flex align-items-center pt-1 ">
                                            <div> {getExtensionIcon(file_data?.split('.').pop(), 15, 15, doc?.document_link)}</div>
                                            <div className="ms-2"> {doc?.document_name}</div>
                                        </div>
                                    </td>
                                    <td className="pt-1">{doc?.created && format(new Date(doc?.created), 'dd/MM/yyyy')}</td>
                                    <td style={{ width: 40 }}>
                                        {' '}
                                        <div className={styles?.dropdown}>
                                            <BsThreeDotsVertical />
                                            <div className={styles.hoverMenuContent}>
                                                <div
                                                    style={{
                                                        width: '150px',
                                                        top: 15,
                                                        cursor: 'pointer',
                                                    }}
                                                    className={styles.hoverMenuCont}>
                                                    <ViewDocumentModal
                                                        workstream={workstream}
                                                        doc={doc}
                                                        selectedFolder={selectedFolder}
                                                        file_data={file_data}
                                                        checkPermission={checkPermission}
                                                        selectedPDF={selectedPDF}
                                                        file_meta={doc}
                                                    />
                                                    <hr className="mt-2 mb-2" />
                                                    <DoubleConfirmationModal
                                                        handleAction={() => handleDeleteFile(doc?.id)}
                                                        message={'Deleting a Folder will also delete all files in the folder'}>
                                                        {' '}
                                                        <div className={styles.wsChipMenuItem} style={{ color: 'var(--Brand-Secondary)' }}>
                                                            <RiDeleteBin6Line className="me-2" />
                                                            Delete File
                                                        </div>
                                                    </DoubleConfirmationModal>
                                                </div>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
                <div
                    ref={tableRef}
                    onDragEnter={handleDragEnter}
                    onDragLeave={handleDragLeave}
                    onDragOver={handleDragOver}
                    onDrop={handleDrop}
                    className={(dragging && styles?.dragging) + ' add-file-step ' + styles.tableDragDrop}>
                    <div className="text-center">
                        <BsCloudUpload size={40} />
                        <br />
                        <p>Drag and drop files here</p>
                    </div>
                </div>
            </div>
        </>
    );
};
const AddDocumentModal = ({ selectedFolder, workstream }) => {
    const [showModal, setShowModal] = React.useState(false);
    const { user } = useSelector(state => state.user);
    const { projectUsersAll } = useSelector(state => state.team);
    const [document_link, set_document_link] = React.useState('');
    const [docName, setDocName] = React.useState('');
    const [selectedOption, setSelectedOption] = React.useState();
    const { items, default_workstreams, default_folders } = useSelector(state => state?.dataroom);
    const { selectedProject } = useSelector(state => state?.projectData);
    const [selectedFiles, setSelectedFiles] = React.useState([]);
    const dispatch = useDispatch();
    const handleClose = () => {
        setShowModal(false);
        set_document_link('');
        setDocName('');
        setSelectedFiles([]);
    };
    const handleAddFile = async () => {
        const filePromiseToast = toast.loading(`Uploading ${selectedFiles?.length} documents to ${selectedFolder?.name}`, { closeButton: true });
        const formData = new FormData();
        for (const item of selectedFiles) {
            formData.append('document', item);
        }
        formData.append('ws_folder', parseInt(selectedOption));
        formData.append('project', selectedProject?.id);
        formData.append('vdr', selectedProject?.vdr?.id);
        if (selectedProject?.vdr?.vdr_admin !== user?.id) {
            formData.append('upload_by', projectUsersAll?.find(projectUser => projectUser?.value?.user_id === user?.id)?.value?.group_member_id);
        }
        try {
            let res = await dispatch(PostIRLDocuments({ body: formData, ws_id: workstream }));
            dispatch(setIRLItemsRecieved({ id: selectedOption, flag: true }));

            if (res?.type === 'POST_IRL_DOC/rejected') {
                console.log(res);
                if (res?.payload?.detail) {
                    toast.update(filePromiseToast, {
                        render: res?.payload?.detail,
                        type: 'error',
                        isLoading: false,
                        autoClose: 2000,
                    });
                } else {
                    toast.update(filePromiseToast, {
                        render: `Uploading  Failed`,
                        type: 'error',
                        isLoading: false,
                        autoClose: 2000,
                    });
                }
            } else {
                // If the upload is successful, update the file-specific toast
                toast.update(filePromiseToast, {
                    render: `Uploaded successfully`,
                    type: 'success',
                    isLoading: false,
                    autoClose: 2000,
                });
            }
        } catch (uploadError) {
            console.error(`Error uploading`, uploadError);
            toast.update(filePromiseToast, {
                render: `Error uploading`,
                type: 'error',
                isLoading: false, // Make sure to update the loading state in case of an error
                autoClose: 2000,
            });
        }
    };

    const handleAddLinkAsFile = async promiseToast => {
        let allRequestsSucceeded = true;
        if (document_link) {
            // Validate URL before submitting to prevent XSS attacks
            const { validateUrl } = require('../../utils/urlValidation');
            let validatedUrl;
            try {
                validatedUrl = validateUrl(document_link);
            } catch (error) {
                toast.update(promiseToast, {
                    render: error.message || 'Invalid URL. Only http://, https://, and ftp:// URLs are allowed.',
                    type: 'error',
                    isLoading: false,
                    autoClose: 3000,
                });
                return false;
            }

            let formData = new FormData();
            formData.append('ws_folder', selectedOption);
            formData.append('project', selectedProject?.id);
            formData.append('vdr', selectedProject?.vdr?.id);
            if (selectedProject?.vdr?.vdr_admin !== user?.id) {
                formData.append('upload_by', projectUsersAll?.find(item => item?.value?.user_id === user?.id)?.value?.group_member_id);
            }
            formData.append('document_link', validatedUrl);
            formData.append('document_name', docName || validatedUrl.split('/').pop());

            try {
                let res = await dispatch(PostIRLDocuments({ body: formData, ws_id: workstream }));
                dispatch(setIRLItemsRecieved({ id: selectedOption, flag: true }));

                if (res?.type === 'POST_IRL_DOC/rejected') {
                    toast.update(promiseToast, {
                        render: res?.payload?.detail,
                        type: 'error',
                        isLoading: false,
                        autoClose: 2000,
                    });
                    allRequestsSucceeded = false;
                }

                set_document_link('');
                setDocName('');
            } catch (error) {
                console.error('Error adding link as file:', error);
                allRequestsSucceeded = false;
            }
        }
        return allRequestsSucceeded;
    };

    const handleSubmit = async () => {
        // promiseToast = toast.loading('Uploading...', { closeButton: true });
        if (selectedFiles?.length > 0) {
            handleAddFile();
        } else {
            handleAddLinkAsFile();
        }

        handleClose();
    };

    React.useEffect(() => {
        if (selectedFolder) {
            setSelectedOption(selectedFolder?.id);
        } else setSelectedOption(null);
    }, [selectedFolder]);

    React.useEffect(() => {
        if (showModal) {
            if (selectedFolder) {
                setSelectedOption(selectedFolder?.id);
            } else {
                let defaultWorkstream = default_workstreams?.find(item => item?.id === workstream);
                if (defaultWorkstream) default_folders?.length > 0 && setSelectedOption(default_folders[0]?.id);
                else items?.filter(item => item?.requested)?.length > 0 && setSelectedOption(items?.find(item => item?.requested)?.id);
            }
        }
    }, [showModal]);
    React.useEffect(() => {
        if (showModal) {
            let defaultWorkstream = default_workstreams?.find(item => item?.id === workstream);
            if (defaultWorkstream) default_folders?.length > 0 && setSelectedOption(default_folders[0]?.id);
            else items?.filter(item => item?.requested)?.length > 0 && setSelectedOption(items?.find(item => item?.requested)?.id);
        }
    }, [default_folders]);

    return (
        <>
            <button onClick={() => setShowModal(true)} className={'btn btn-primary btn-sm ' + styles.smallButton}>
                Add Files &nbsp;
                <AiOutlinePlus />
            </button>

            <Offcanvas placement="end" show={showModal} onHide={handleClose}>
                <Offcanvas.Body className={styles.sidebarBody}>
                    <div className="d-flex justify-content-between">
                        <div>
                            <svg width="25px" height="24px" viewBox="0 0 25 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXLink="http://www.w3.org/1999/xlink">
                                <title>Group 6</title>
                                <g id="★★-Dataroom" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                                    <g id="Consultant_Dataroom_Folder_Add-Files" transform="translate(-987.000000, -80.000000)" fill="#003149">
                                        <g id="Group-10" transform="translate(955.000000, 60.000000)">
                                            <g id="Group-6" transform="translate(32.000000, 20.000000)">
                                                <path
                                                    d="M12.3568128,2.47705643 L12.3568128,6.01114619 L15.8982977,6.01114619 C14.717118,4.83243153 13.5411032,3.65888177 12.3568128,2.47705643 M22.6312863,17.6498017 C22.6309342,14.9314156 20.3933542,12.7012308 17.6718574,12.7066792 C14.9547039,12.7121476 12.7349663,14.9253116 12.7250731,17.6388262 C12.7151871,20.3535734 14.9470739,22.588747 17.6725618,22.5936264 C20.3942346,22.5984899 22.6315798,20.3677769 22.6312863,17.6498017 M16.9583368,11.3182674 L16.9583368,7.43713093 L16.6691606,7.43713093 C15.041627,7.43713093 13.414152,7.43842216 11.7866184,7.43636793 C11.200988,7.43560493 10.939984,7.17319228 10.9397492,6.5936072 C10.9390449,4.95368953 10.9394558,3.31371318 10.9394558,1.67373682 C10.9394558,1.59121564 10.9394558,1.50863577 10.9394558,1.43110343 L1.42117198,1.43110343 L1.42117198,22.5819974 L13.6472186,22.5819974 C11.6259193,20.7356007 10.8228931,18.4941471 11.5928169,15.8721335 C12.3639145,13.2461288 14.2545064,11.7937326 16.9583368,11.3182674 M18.171093,24 L0.516491015,24 C0.344346907,23.828208 0.172144107,23.6563574 0,23.4845068 C0,15.8303447 0,8.17612393 0,0.521903167 C0.187462761,0.11616426 0.510152261,-0.00139613811 0.946176323,-1.77635684e-15 C4.45080263,0.0114574451 7.95542893,0.00916845083 11.4600552,0.00194931506 C11.7898465,0.00130370129 12.0401685,0.105364902 12.271357,0.337316322 C14.1915884,2.26324088 16.1161043,4.1849983 18.0469004,6.10041697 C18.2875382,6.33917668 18.3890757,6.59865472 18.386728,6.9334935 C18.3770438,8.30753567 18.3826782,9.68175393 18.3826782,11.0558548 C18.3826782,11.1468863 18.3826782,11.2379179 18.3826782,11.3311797 C18.4584498,11.3460288 18.5035841,11.35495 18.548777,11.3636365 C18.5947917,11.372499 18.640865,11.3812441 18.6869971,11.3898132 C21.1085769,11.8395125 22.7678043,13.2201869 23.6494779,15.5046619 C23.8515551,16.028196 23.9137687,16.6055507 24.040309,17.1580787 L24.040309,18.1422289 C23.9991658,18.3872687 23.9715218,18.6354778 23.9148839,18.8769374 C23.3134653,21.4419022 21.7466194,23.0935583 19.2020795,23.8054355 C18.8665364,23.8993429 18.5151464,23.9365538 18.171093,24"
                                                    id="Fill-1"></path>
                                                <path
                                                    d="M16.9734677,18.3457557 C16.5453671,18.3457557 16.1478451,18.3637742 15.7526707,18.3410603 C15.2884744,18.3144141 15.0065173,17.9102599 15.1161543,17.4710077 C15.1861153,17.1905766 15.4126084,16.984391 15.7177489,16.9623228 C16.0056926,16.9415458 16.295808,16.9504083 16.5849256,16.9471215 C16.7010187,16.9458303 16.8171705,16.9469454 16.9734677,16.9469454 C16.9734677,16.7912351 16.9720004,16.6544824 16.9737611,16.5177297 C16.9774001,16.2369464 16.9661899,15.9547545 16.9916036,15.675908 C17.0237669,15.3224638 17.3297291,15.0646878 17.6782432,15.0647465 C18.0267572,15.0648639 18.333952,15.3226399 18.3643545,15.6762015 C18.3903551,15.9785248 18.3784406,16.2841349 18.3824317,16.5882776 C18.3838403,16.6958017 18.3826665,16.8033844 18.3826665,16.9472389 C18.7622287,16.9472389 19.1187835,16.9480606 19.4752797,16.9470041 C19.7481396,16.9461824 19.9838473,17.0213084 20.1446638,17.2594812 C20.4319033,17.685058 20.1835767,18.2739165 19.6731897,18.3317283 C19.3563107,18.3676479 19.0331517,18.3484555 18.7128099,18.3531509 C18.613444,18.3546182 18.5139608,18.3533857 18.3819622,18.3533857 C18.3819622,18.744745 18.3873618,19.1089886 18.3804362,19.4729973 C18.3734518,19.838356 18.2075291,20.0879738 17.9199962,20.1916242 C17.4919542,20.3459258 17.0392029,20.0702488 16.9890211,19.6128021 C16.9670116,19.4120162 16.9760501,19.2077088 16.9739372,19.0049861 C16.9718243,18.8026742 16.9734677,18.6003036 16.9734677,18.3457557"
                                                    id="Fill-4"></path>
                                            </g>
                                        </g>
                                    </g>
                                </g>
                            </svg>
                            <b className="ms-3">Add Files</b>
                        </div>
                        <IoIosClose onClick={handleClose} color="var(--Brand-Secondary)" size={20} />
                    </div>
                    <div className="mt-5 mt-4">
                        <div className="mb-3 ">
                            <label className="form-check-label me-4 bold mb-0 smallFont" htmlFor="flexRadioDefault1">
                                Select Folder
                            </label>
                            <select
                                name="theme"
                                value={selectedOption}
                                onChange={e => setSelectedOption(parseInt(e.target.value))}
                                className="form-select"
                                placeholder="Select Impact"
                                aria-label=". example">
                                {items?.map(
                                    item =>
                                        item?.requested && (
                                            <option key={item?.id} value={item?.id}>
                                                {item?.prefix + ' - ' + item?.name}
                                            </option>
                                        ),
                                )}
                                {default_folders?.map(item => {
                                    let check = items?.find(it => it?.name === item?.ws_folder);
                                    if (!check) {
                                        return (
                                            <option key={item?.id} value={item?.id}>
                                                {item?.ws_folder}
                                            </option>
                                        );
                                    }
                                })}
                            </select>
                        </div>
                        <div className="mb-3 ">
                            {selectedFiles?.length > 0 ? (
                                <div>
                                    <label className="form-check-label me-4 bold mb-0 smallFont" htmlFor="flexRadioDefault1">
                                        Uploaded Files
                                    </label>
                                    <div>
                                        {selectedFiles?.map(item => (
                                            <div key={item?.name} className={styles.fileListItem}>
                                                <span className={styles.smallFont}>{item?.name}</span>
                                                <AiOutlineClose size={14} onClick={() => setSelectedFiles(selectedFiles?.filter(file => file?.name !== item?.name))} />
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            ) : (
                                <>
                                    <label className="form-check-label me-4 bold mb-0 smallFont" htmlFor="flexRadioDefault1">
                                        Upload File
                                    </label>
                                    <div className="input-browse-file mb-2">
                                        <DocDragDrop uploadLink={true} multiple={true} onFileChange={files => setSelectedFiles(Array.from(files))} placeholder="Upload Documents" />
                                    </div>
                                </>
                            )}
                            {selectedFiles?.length === 0 && (
                                <>
                                    <div className="mb-3 mt-3">
                                        <p className="smallFont  mb-1">Or add link to file</p>
                                        <input
                                            onChange={e => set_document_link(e.target.value)}
                                            value={document_link}
                                            type="text"
                                            className={'form-control  '}
                                            placeholder="Type here"
                                            aria-label="Type here"
                                            aria-describedby="basic-addon2"
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <p className="smallFont  mb-1">Add Text to Display</p>
                                        <input
                                            onChange={e => setDocName(e.target.value)}
                                            value={docName}
                                            type="text"
                                            className={'form-control  '}
                                            placeholder="Type here"
                                            aria-label="Type here"
                                            aria-describedby="basic-addon2"
                                        />
                                    </div>
                                </>
                            )}
                        </div>
                        {/* <DocumentList id={parseInt(selectedOption)} investor={true} ws_id={workstream} /> */}

                        <div className="d-flex justify-content-between align-items-center">
                            <button
                                disabled={selectedFiles?.length === 0 && (!docName || !document_link)}
                                style={{ width: '90px' }}
                                onClick={handleSubmit}
                                className={'btn btn-primary btn-sm mt-3 ' + styles.smallButton}>
                                Save
                            </button>
                        </div>
                    </div>
                </Offcanvas.Body>
            </Offcanvas>
        </>
    );
};
export const PDFViewer = ({ selectedPDF, selectedFolder, setShowPDF, workstream, folderFiles, setSelectedFileIndex, selectedFileIndex, setSelectedPDF }) => {
    const [pdfUrl, setPdfUrl] = React.useState(null);
    const viewer = React.useRef(null);
    const [showSidebar, setShowSidebar] = React.useState(false);
    const { user } = useSelector(state => state.user);
    const { projectUsersAll } = useSelector(state => state.team);
    const [isVideo, setIsVideo] = React.useState(false);
    const [isAudio, setIsAudio] = React.useState(false);
    const [pdfLoading, setPdfLoading] = React.useState(false);
    const instanceRef = React.useRef(null);
    const dispatch = useDispatch();

    useEffect(() => {
        if (pdfUrl) {
            if (!instanceRef?.current) {
                WebViewer(
                    {
                        webviewerServerURL: process.env.REACT_APP_PDF_WEBVIEWER_URL,
                        licenseKey: process.env.REACT_APP_PDF_EXPRESS_KEY,
                        path: '/webviewer/lib',
                        initialDoc: pdfUrl,
                        extension: selectedPDF?.document ? selectedPDF?.document?.split('.').pop() : selectedPDF?.document_link?.split('.').pop(),
                    },
                    viewer.current,
                )
                    .then(async instance => {
                        const { Core } = instance;
                        instanceRef.current = instance;
                        setPdfLoading(false);
                        instance.UI.disableElements(['toolsHeader']);
                        // instance.UI.disableElements(['toolbarGroup-Annotate']);
                        instance.UI.disableElements(['ribbons']);
                        instance.UI.disableElements(['toggleNotesButton']);
                        instance.UI.disableElements(['menuButton']);
                        Core.documentViewer.addEventListener('documentLoaded', () => {
                            // setPdfLoading(false);
                            workstream && handleReadDoc();
                        });
                    })
                    .catch(err => {
                        setPdfLoading(false);
                    });
            } else {
                instanceRef.current?.UI?.loadDocument(pdfUrl);
            }
        }
    }, [pdfUrl]);

    useEffect(() => {
        if (selectedPDF) {
            const efectFunction = async () => {
                setPdfLoading(true);
                setIsVideo(handleCheckVideo(selectedPDF));
                if (selectedPDF?.document_link?.includes('youtube')) {
                    setPdfUrl(selectedPDF?.document_link);
                } else {
                    if (selectedPDF?.document_link) setPdfUrl(selectedPDF?.document_link);
                    else {
                        if (isAudioFile(selectedPDF?.document)) setIsAudio(true);
                        setPdfUrl(selectedPDF?.document);
                    }
                }
            };
            efectFunction();
        }
    }, [selectedPDF]);
    const handleReadDoc = () => {
        const id = projectUsersAll?.find(item => item?.user_id === user?.id)?.value?.group_member_id;
        const isAlreadyPresent = selectedPDF?.read_by?.find(item => item === id);
        if (!isAlreadyPresent) {
            dispatch(GetIRLDocData({ id: selectedPDF?.id, workstream }));
        }
    };
    const handleCheckVideo = row => {
        if (row?.document_link?.includes('youtube')) {
            workstream && handleReadDoc();
            return true;
        }
        let ext = row?.document_name?.split('.').pop();
        // eslint-disable-next-line default-case
        switch (ext.toLowerCase()) {
            case 'm4v':
            case 'avi':
            case 'mpg':
            case 'mov':
            case 'mp5':
            case 'mp4':
                workstream && handleReadDoc();
                return true;
        }
        return false;
    };
    const handleNavigateFiles = direction => {
        if (direction === 'prev') {
            console.log('prev');

            setSelectedFileIndex(selectedFileIndex - 1);
            setSelectedPDF(folderFiles[selectedFileIndex - 1]);
        } else {
            console.log('next');
            setSelectedFileIndex(selectedFileIndex + 1);
            setSelectedPDF(folderFiles[selectedFileIndex + 1]);
        }
    };
    return (
        <div className="">
            <div className="row">
                <div className={`col-sm-12 col-md-${showSidebar ? 8 : 12}`}>
                    <div style={{ fontSize: 13 }} className="pt-3 pb-3 d-flex justify-content-between align-items-center">
                        <span>
                            {' '}
                            <b>{selectedFolder?.name}</b> / {selectedPDF?.document_name}
                        </span>
                        <div>
                            <b
                                onClick={() => {
                                    window.history.pushState(null, '', '/dataroom');
                                    setShowPDF(false);
                                }}
                                className={styles.orangeText}>
                                Back
                            </b>
                            asd
                            {!showSidebar && user?.has_diligence_tools && (
                                <button onClick={() => setShowSidebar(true)} style={{ marginLeft: '40px' }} className="btn btn-primary smallButton ">
                                    New Observation
                                </button>
                            )}
                        </div>
                    </div>
                    {(selectedFileIndex || selectedFileIndex === 0) && (
                        <div className="d-flex justify-content-between align-items-center mb-3">
                            <div
                                style={{ color: selectedFileIndex === 0 && 'var(--muted)', pointerEvents: selectedFileIndex === 0 && 'none' }}
                                className={styles.navigationIcons}
                                onClick={() => selectedFileIndex > 0 && handleNavigateFiles('prev')}>
                                <IoCaretBack size={20} />
                                Prev
                            </div>
                            <div
                                style={{
                                    color: selectedFileIndex === folderFiles?.length - 1 && 'var(--muted)',
                                    pointerEvents: selectedFileIndex === folderFiles?.length - 1 && 'none',
                                }}
                                onClick={() => folderFiles?.length - 1 !== selectedFileIndex && handleNavigateFiles('next')}
                                className={styles.navigationIcons}>
                                Next
                                <IoCaretForward size={20} />
                            </div>
                        </div>
                    )}

                    <div className={styles.docContainer}>
                        {/* getYouTubeId */}
                        {isVideo && (
                            <div>
                                {pdfUrl?.includes('youtube') ? (
                                    <iframe
                                        width="100%"
                                        height="70vh"
                                        src={`https://www.youtube.com/embed/${getYouTubeId(pdfUrl)}`}
                                        frameborder="0"
                                        title="youtube-vid"
                                        allowfullscreen></iframe>
                                ) : (
                                    <video
                                        src={pdfUrl}
                                        controls
                                        style={{
                                            height: '70vh',
                                            width: '100%',
                                        }}
                                    />
                                )}
                            </div>
                        )}
                        {isAudio && pdfUrl && (
                            <div
                                className="d-flex align-items-center justify-content-center"
                                style={{
                                    height: '70vh',
                                    width: '100%',
                                }}>
                                <audio controls controlsList="nodownload">
                                    <source src={pdfUrl} />
                                    Your browser does not support the audio element.
                                </audio>
                            </div>
                        )}
                        {!isVideo && !isAudio && (
                            <div className={'webviewer'} ref={viewer}>
                                {pdfLoading && (
                                    <div className={styles.loaderBody}>
                                        <AiOutlineLoading3Quarters size={50} className="rotateLoader" />
                                    </div>
                                )}
                            </div>
                        )}
                    </div>
                </div>
                {showSidebar && (
                    <div className="col-sm-12 col-md-4">
                        <ObservationSidebar selectedPDF={selectedPDF} setShowSidebar={setShowSidebar} />
                    </div>
                )}
            </div>
        </div>
    );
};
const ObservationSidebar = ({ selectedPDF, setShowSidebar }) => {
    const dispatch = useDispatch();
    const { user } = useSelector(state => state.user);
    const [imageModalVisible, setImageModalVisible] = React.useState(false);
    const { workstreams } = useSelector(state => state.dataroom);
    const { items, default_folders } = useSelector(state => state?.dataroom);
    const [tagOptions, setTagOptions] = React.useState([]);
    const { obsButtonLoading } = useSelector(state => state.meeting);
    const [observation, setObservation] = React.useState('');
    const [significance, setSignificance] = React.useState('');
    const [previewImage, setPreviewImage] = React.useState();
    const [files, setFiles] = React.useState({ files: null });
    const [formData, setFormData] = React.useState({
        assessment: '',
        swot: '',
        impact: 'HIGH',
        tag: null,
        claim: false,
        workstream: '',
    });

    const handleChange = e => {
        if (e.target?.name === 'swot') {
            if (e.target?.value === 'S' || e.target?.value === 'O') {
                setFormData({ ...formData, [e.target.name]: e.target.value, assessment: 'GREEN' });
            } else if (e.target?.value === 'W' || e.target?.value === 'T') {
                setFormData({ ...formData, [e.target.name]: e.target.value, assessment: 'AMBER' });
            } else {
                setFormData({ ...formData, [e.target.name]: e.target.value });
            }
        } else {
            setFormData({ ...formData, [e.target.name]: e.target.value });
        }
    };
    const handleSubmit = async () => {
        let body = new FormData();
        // formData?.scope && body.append('scope', formData?.scope);
        body.append('workstream_repr', workstreams?.find(item => item?.id === Number(formData?.workstream)).name);
        body.append('tag_repr', formData?.tag?.value);
        body.append('observation', observation);
        body.append('comments', significance);
        body.append('consultant', user?.id);
        body.append('assessment', formData?.assessment);
        body.append('swot', formData?.swot);
        body.append('claim', formData?.claim);
        body.append('added_by', user?.id);
        body.append('docitem', selectedPDF?.id);
        body.append('project', localStorage['project_id']);
        files?.files && body.append('obs_image', files?.files);
        if (formData.swot === 'T' || formData.swot === 'W') {
            body.append('impact', formData?.impact);
        }
        if (formData.swot === 'S' || formData.swot === 'O') {
            body.append('impact', '');
        }
        await dispatch(PostSchedulerObservations({ id: 0, body, type: 'observation' }));
        handleClose();
    };

    const handleClose = () => {
        setShowSidebar(false);
        setFormData({
            assessment: '',
            swot: '',
            impact: 'HIGH',
            tag: null,
            claim: false,
            workstream: '',
        });
        setSignificance('');
        setObservation('');
        setFiles({ files: null });
    };
    const handleAddFile = async file => {
        setFiles({ files: file });
        var reader = new FileReader();
        reader.onloadend = function () {
            setPreviewImage(reader.result);
        };
        reader.readAsDataURL(file);
    };

    function encodeImageFileAsURL(element) {
        var file = element.files[0];
        var reader = new FileReader();
        reader.onloadend = function () {
            setPreviewImage(reader.result);
        };
        reader.readAsDataURL(file);
    }
    const handlePasteFile = e => {
        if (e.clipboardData.files.length) {
            encodeImageFileAsURL(e.clipboardData);
            const fileObject = e.clipboardData.files[0];
            setFiles({ files: fileObject });
        } else {
            alert('No image data was found in your clipboard. Copy an image first or take a screenshot.');
        }
    };

    React.useEffect(() => {
        if (formData?.workstream) {
            dispatch(GetIRLDoc(formData?.workstream));
            dispatch(GetDataroomItemInfo(formData?.workstream));
        }
    }, [formData?.workstream]);
    React.useEffect(() => {
        const combinedOptions = [...new Set([...default_folders.map(folder => folder?.ws_folder), ...items.map(item => item?.name)])].map(label => ({ label, value: label }));
        setTagOptions(combinedOptions);
    }, [default_folders, items]);

    return (
        <div className={styles.sidebarBody}>
            <div>
                <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <g fill="#003149" fillRule="evenodd">
                        <path d="M17.255 16.03c.041.039.1.088.153.142l2.743 2.722c.714.71 1.43 1.419 2.14 2.133.258.258.342.573.23.926a.875.875 0 0 1-.695.624c-.351.073-.637-.06-.885-.31-1.609-1.626-3.22-3.25-4.83-4.875-.042-.043-.077-.092-.098-.116l1.242-1.245zM8.623 1.407c3.97.005 7.203 3.247 7.202 7.222-.001 3.975-3.237 7.215-7.206 7.218-3.979.002-7.224-3.252-7.214-7.234.01-3.978 3.247-7.21 7.218-7.206zM0 9.236c.078.46.136.924.238 1.38.73 3.282 3.554 5.95 6.87 6.5 2.557.423 4.855-.173 6.897-1.768.036-.029.075-.054.116-.084.03.019.058.032.08.052l.91.845c-.201.19-.398.365-.582.552-.333.34-.338.738-.004 1.076 1.823 1.843 3.65 3.682 5.473 5.524.66.667 1.727.88 2.59.498.34-.15.652-.346.895-.636a2.28 2.28 0 0 0 .463-1.934c-.115-.5-.426-.931-.762-1.306a7.855 7.855 0 0 0-.347-.36c-1.678-1.645-3.337-3.308-5.003-4.964-.422-.42-.789-.42-1.209 0-.176.177-.346.36-.527.547l-.952-.888c.19-.257.383-.5.559-.755 3.15-4.554 1.215-10.89-3.94-12.913C6.75-1.365 1.207 1.68.16 6.979.092 7.322.053 7.67 0 8.017v1.219z" />
                        <path d="M8.282 11.863c-.203-.037-.6-.07-.972-.185-1.622-.503-2.646-1.631-3.328-3.097-.031-.067-.005-.178.029-.254.37-.82.895-1.534 1.601-2.112 1.197-.98 2.553-1.374 4.076-.905 1.612.497 2.625 1.637 3.298 3.097.029.062.004.163-.027.233a5.716 5.716 0 0 1-1.041 1.583c-.922.994-2.035 1.612-3.636 1.64m.386 1.378c1.584-.037 3.017-.758 4.205-1.985A6.876 6.876 0 0 0 14.422 8.8c.059-.162.087-.378.028-.532-.783-2.052-2.151-3.575-4.328-4.27-1.895-.604-3.634-.18-5.193.979a6.905 6.905 0 0 0-2.386 3.201c-.063.168-.086.393-.024.554.747 1.94 2.041 3.39 4.051 4.168.614.238 1.26.34 2.098.341" />
                        <path d="M9.287 8.483a.799.799 0 0 1-.787.79.799.799 0 0 1-.823-.778.797.797 0 0 1 .787-.79.8.8 0 0 1 .823.778m-3.032.026c.01 1.192 1.025 2.16 2.254 2.147 1.224-.012 2.214-1.001 2.2-2.2-.014-1.18-1.023-2.14-2.242-2.134-1.227.007-2.222.99-2.212 2.187" />
                        <g fillRule="nonzero">
                            <path d="M20.897 0c.338 0 .614.136.62.304v5.593c0 .171-.278.31-.62.31-.34 0-.615-.136-.621-.304V.31c0-.171.278-.31.62-.31z" />
                            <path d="M23.69 2.483c.171 0 .31.278.31.62 0 .34-.136.615-.304.621h-5.593c-.171 0-.31-.278-.31-.62 0-.34.136-.615.304-.621h5.593z" />
                        </g>
                    </g>
                </svg>

                <b className="ms-3">Add New Observation</b>
            </div>
            <div className="mt-5">
                <div className="mt-1 mb-3">
                    <label className={'form-check-label me-4 bold mb-1 ' + styles.smallFont} htmlFor="flexRadioDefault1">
                        Workstream <span style={{ color: 'var(--danger)' }}>*</span>
                    </label>
                    <select
                        name="workstream"
                        value={formData.workstream}
                        onChange={e =>
                            setFormData({
                                ...formData,
                                workstream: e.target.value,
                            })
                        }
                        className="form-select "
                        placeholder="Select Workstream"
                        aria-label=".form-select-sm example">
                        <option value="">None</option>
                        {workstreams?.map(item => (
                            <option key={item?.id} value={item?.id}>
                                {item?.name}
                            </option>
                        ))}
                    </select>
                </div>
                <div className="mb-2">
                    <label className={'form-check-label me-4 bold mb-1 ' + styles.smallFont} htmlFor="flexRadioDefault1">
                        Tag <span style={{ color: 'var(--danger)' }}>*</span>
                    </label>
                    <Select
                        name="selectedAssignee"
                        options={tagOptions}
                        isDisabled={!formData?.workstream}
                        className="basic-multi-select"
                        classNamePrefix="select"
                        value={formData?.tag}
                        onChange={e => setFormData({ ...formData, tag: e })}
                        placeholder="Type here"
                        maxMenuHeight={1000}
                        isClearable
                    />
                </div>
                <br />
                <div className=" mb-4">
                    <p style={{ marginBottom: -33 }} className={'form-label bold  ' + styles.smallFont} htmlFor>
                        Add Observation <span style={{ color: 'var(--danger)' }}>*</span>
                    </p>

                    <ReactQuill
                        modules={{
                            toolbar: [['bold', 'italic', 'underline'], [{ list: 'ordered' }, { list: 'bullet' }], ['link']],
                        }}
                        placeholder="Type here"
                        theme="snow"
                        defaultValue={observation || ''}
                        onChange={v => setObservation(v)}
                        value={observation}
                    />
                </div>
                <div className=" mb-4">
                    <p style={{ marginBottom: -33 }} className={'form-label bold  ' + styles.smallFont} htmlFor>
                        Add Significance
                    </p>

                    <ReactQuill
                        modules={{
                            toolbar: [['bold', 'italic', 'underline'], [{ list: 'ordered' }, { list: 'bullet' }], ['link']],
                        }}
                        placeholder="Add your remarks or mitigation"
                        theme="snow"
                        defaultValue={significance || ''}
                        value={significance}
                        onChange={v => setSignificance(v)}
                    />
                </div>

                <div className="row mt-3">
                    <div className="col-sm-12 col-md-6 ">
                        {' '}
                        <label className={'form-check-label me-4 bold ' + styles.smallFont} htmlFor="flexRadioDefault1">
                            SWOT
                        </label>
                        <select name="swot" value={formData.swot} onChange={handleChange} className="form-select " placeholder="Select Impact" aria-label=". example">
                            <option value="">None</option>
                            <option value="S">Strength</option>
                            <option value="W">Weakness</option>
                            <option value="O">Opportunity</option>
                            <option value="T">Threat</option>
                        </select>
                    </div>
                </div>

                {/* Divider between Assessment and SWOT Analysis */}
                <hr style={{ marginTop: 20, marginBottom: 20, borderColor: 'var(--Neutral-Gray-5)' }} />

                <div className="row">
                    <div className="col-sm-12 col-md-6">
                        {' '}
                        <label className={'form-check-label me-4 bold ' + styles.smallFont} htmlFor="flexRadioDefault1">
                            Assessment <span style={{ color: 'var(--danger)' }}>*</span>
                        </label>
                        <div className="mt-1">
                            <div className="  me-4">
                                <select
                                    name="assessment"
                                    value={formData.assessment}
                                    onChange={handleChange}
                                    className="form-select "
                                    placeholder="Select Assessment"
                                    aria-label=". example">
                                    <option value="">None</option>
                                    <option value="RED">Red</option>
                                    <option value="AMBER">Amber</option>
                                    <option value="GREEN">Green</option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <div className="col-sm-12 col-md-6">
                        <div className="text-center">
                            <label htmlFor className={'form-check-label ms-3  bold mb-0 ' + styles.smallFont}>
                                Project Claim
                            </label>
                            <br />
                            <input
                                type="checkbox"
                                checked={formData?.claim}
                                onChange={e => setFormData({ ...formData, claim: e.target.checked })}
                                className={styles.claimCheckbox + ' mt-2'}
                            />
                        </div>
                    </div>
                </div>
                <div className="row mt-3">
                    <div className="col-sm-12 col-md-6">
                        {(formData.swot === 'T' || formData.swot === 'W') && (
                            <div className="">
                                <label className={'form-check-label me-4 bold ' + styles.smallFont} htmlFor="flexRadioDefault1">
                                    Select Impact
                                </label>
                                <select name="impact" value={formData.impact} onChange={handleChange} className="form-select " placeholder="Select Impact" aria-label=". example">
                                    <option value="HIGH">High</option>
                                    <option value="MEDIUM">Medium</option>
                                    <option value="LOW">Low</option>
                                </select>
                            </div>
                        )}
                    </div>
                </div>
                <div className="mt-3">
                    <div className="d-flex justify-content-between align-items-center">
                        <label className={'form-check-label me-4 bold mb-1 ' + styles.smallFont} htmlFor="flexRadioDefault1">
                            Add Image
                        </label>
                        <div>{previewImage && <FaRegImages onClick={() => setImageModalVisible(true)} size={15} />}</div>
                    </div>
                    <div className="d-flex">
                        <div className={styles.fileUploadBody} onPaste={handlePasteFile}>
                            <FileUploader children="Choose File" handleChange={handleAddFile} name="file" />
                            {files?.files?.name ? files?.files?.name : ' Click Here and Paste'}
                        </div>
                    </div>
                </div>
                <div className="mt-5 d-flex justify-content-between align-items-center">
                    <button
                        disabled={!Boolean(observation && formData?.workstream && formData?.tag && formData?.assessment && observation !== '<p><br></p>')}
                        onClick={handleSubmit}
                        type="button"
                        className={`btn btn-primary btn-sm ${styles.smallFont}`}>
                        Add Observation &nbsp;
                        {obsButtonLoading && <AiOutlineLoading3Quarters className="rotateLoader" />}
                    </button>
                    <p onClick={handleClose} className={styles.orangeBtnText}>
                        Cancel
                    </p>
                </div>
            </div>
            {previewImage && <ImageModal image={previewImage} setModalVisible={setImageModalVisible} modalVisible={imageModalVisible} />}
        </div>
    );
};
export const ViewDocumentModal = ({ doc, selectedFolder, file_data, workstream, checkPermission, file_meta }) => {
    const [showModal, setShowModal] = React.useState(false);
    const { data } = useSelector(state => state?.documents);
    const { projectUsersAll, workstreams } = useSelector(state => state?.team);
    const { selectedProject } = useSelector(state => state?.projectData);
    const { user } = useSelector(state => state?.user);
    const [deleteBtnLoading, setDeleteBtnLoading] = React.useState(false);
    const isProjectAdmin = selectedProject?.vdr?.vdr_admin === user?.id || selectedProject?.project_admins?.some(admin => admin.user_id === user?.id);
    const [pdfUrl, setPdfUrl] = React.useState(null);
    const viewer = React.useRef(null);
    const instanceRef = React.useRef(null);
    const dispatch = useDispatch();
    const handleClose = () => {
        setShowModal(false);
    };
    const getUserDetail = id => {
        let addedBy = projectUsersAll?.find(item => item?.value?.group_member_id === id);
        return (
            <>
                <p className={styles.smallFont + ' m-0'}>{addedBy?.value?.full_name || 'Project Admin'} </p>
                <p className={styles.smallFont + ' m-0'}>{addedBy?.value?.organisation}</p>
            </>
        );
    };
    const getUserNameByGroupMemberId = id => {
        let user = projectUsersAll?.find(item => item?.value?.group_member_id === id);
        return <p className={styles.smallFont + ' m-0'}>{user?.value?.full_name}</p>;
    };
    const handleDeleteFile = id => {
        setDeleteBtnLoading(true);
        axiosInstance
            .delete(`${IRL_DOC}${localStorage['project_id']}/${workstream}/${id}/`)
            .then(res => {
                const deleted = data?.find(file => file.id === id);
                console.log(deleted);
                toast.success('Deleted');
                const newList = data?.filter(file => file.id !== id);
                dispatch(setDocs(newList));
                if (deleted) {
                    let check = newList?.find(item => item?.ws_folder_id === deleted?.ws_folder_id);
                    if (!check) {
                        dispatch(
                            setIRLItemsRecieved({
                                id: deleted?.ws_folder_id,
                                flag: false,
                            }),
                        );
                    }
                }
                setDeleteBtnLoading(false);
                handleClose();
            })
            .catch(err => {
                setDeleteBtnLoading(false);
                handleClose();
                const errorMessage = err?.response?.data?.detail || 'Failed to delete document';
                toast.error(errorMessage);
            });
    };
    useEffect(() => {
        const effectAsync = async () => {
            if (doc && showModal) {
                setPdfUrl(doc?.document || doc?.document_link);
            }
        };
        effectAsync();
    }, [doc, showModal]);
    useEffect(() => {
        if (pdfUrl && showModal)
            WebViewer(
                {
                    webviewerServerURL: process.env.REACT_APP_PDF_WEBVIEWER_URL,
                    licenseKey: process.env.REACT_APP_PDF_EXPRESS_KEY,
                    path: '/webviewer/lib',
                    initialDoc: pdfUrl,
                    extension: doc?.document_name?.split('.').pop() || 'pdf',
                },
                viewer.current,
            )
                .then(async instance => {
                    //instance.setFitMode(instance.FitMode.FitWidth);
                    const { Core } = instance;

                    instanceRef.current = instance;
                    Core.documentViewer.addEventListener('documentLoaded', () => {});
                    Core.documentViewer.addEventListener('pageNumberUpdated', pageNumber => {
                        console.log(pageNumber);
                    });
                })
                .catch(err => {});
    }, [pdfUrl]);
    const handleDownloadFile = doc => {
        console.log({ instanceRef, doc });
        if (doc?.can_download_original || isProjectAdmin) {
            instanceRef?.current?.UI?.downloadPdf();
            dispatch(GetPopulateDownloadBy({ id: doc?.id, wsId: workstream }));
        }
        if (doc?.can_download_watermarked) {
            handleDownloadWatermarkedFile();
            dispatch(GetPopulateDownloadBy({ id: doc?.id, wsId: workstream }));
        }
    };
    const handleDownloadWatermarkedFile = () => {
        const { Core } = instanceRef.current;
        console.log(Core.documentViewer);
        Core.documentViewer.setWatermark({
            diagonal: {
                fontSize: 40, // or even smaller size
                fontFamily: 'sans-serif',
                color: '#003149',
                opacity: 50, // from 0 to 100
                text: 'www.lens-dd.ai',
            },
        });
        instanceRef?.current?.UI?.downloadPdf();
    };

    return (
        <>
            <div onClick={() => setShowModal(true)} className={styles.wsChipMenuItem}>
                <AiOutlineInfoCircle role="button" size={16} className={styles.rowHiddenItem} /> &nbsp; Get Info
            </div>

            {showModal && (
                <Offcanvas placement="end" show={showModal} onHide={handleClose}>
                    <Offcanvas.Body className={styles.sidebarBody}>
                        <div>
                            <div className="d-flex justify-content-between">
                                <div>
                                    <p className={styles.blueText + ' m-0'}>{selectedFolder?.prefix + '.' + doc?.item_num + ' '}</p>
                                    <p className={styles.smallFont + ' mt-1 mb-1 font-weight-bold'}>{doc?.document_name}</p>
                                    <p className={styles.blueText + ' m-0'}>{selectedFolder?.name}</p>
                                    <p className={styles.blueText + ' m-0'}>{workstreams?.find(item => item?.id === workstream)?.name}</p>
                                </div>
                                <div> {getExtensionIcon(file_data?.split('.').pop(), 24, 24)}</div>
                            </div>
                            <div className={styles.fileMetaBox}>
                                {file_meta?.metadata_storage_size && (
                                    <div className=" d-flex align-items-center ">
                                        <div style={{ width: 20 }}>
                                            <RiDatabase2Line color="#33b5e5" size={15} className="mb-1" />
                                        </div>
                                        <p className={styles.smallFont + ' m-0'}>{getFileSize(file_meta?.metadata_storage_size)}</p>
                                    </div>
                                )}
                                {doc?.read_by?.length > 0 && (
                                    <div className={styles?.dropdown}>
                                        <div className=" d-flex align-items-center ">
                                            <div style={{ width: 20 }}>
                                                <AiOutlineEye color="#22c55e" size={15} className="mb-1" />
                                            </div>
                                            <p className={styles.smallFont + ' m-0'}>{doc?.read_by?.length} User</p>
                                        </div>
                                        <div className={styles.hoverMenuContent}>
                                            <div
                                                style={{
                                                    top: 20,
                                                    left: 0,
                                                }}
                                                className={styles.hoverMenuCont}>
                                                {doc?.read_by?.map((reader_id, index) => (
                                                    <div key={index} className={styles.userName} style={{ border: doc?.read_by?.length === index + 1 && 'none' }}>
                                                        {getUserNameByGroupMemberId(reader_id)}
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    </div>
                                )}
                                {doc?.downloaded_by?.length > 0 && (
                                    <div className={styles?.dropdown}>
                                        <div className=" d-flex align-items-center ">
                                            <div style={{ width: 20 }}>
                                                <AiOutlineCloudDownload color="#33b5e5" size={15} className="mb-1" />
                                            </div>
                                            <p className={styles.smallFont + ' m-0'}>{doc?.downloaded_by?.length} User</p>
                                        </div>
                                        <div className={styles.hoverMenuContent}>
                                            <div
                                                style={{
                                                    top: 20,
                                                    left: 0,
                                                }}
                                                className={styles.hoverMenuCont}>
                                                {doc?.downloaded_by?.map((reader_id, index) => (
                                                    <div key={index} className={styles.userName} style={{ border: doc?.downloaded_by?.length === index + 1 && 'none' }}>
                                                        {getUserNameByGroupMemberId(reader_id)}
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    </div>
                                )}

                                {file_meta?.metadata_page_count && (
                                    <div className=" d-flex align-items-center">
                                        <div style={{ width: 25 }}>
                                            <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                                <g fill="#33B5E5" fillRule="nonzero">
                                                    <path d="M10.317 7.5H7.375A1.884 1.884 0 0 0 5.5 9.372v8.253c0 1.035.818 1.875 1.844 1.875h5.814c1.024 0 1.842-.84 1.842-1.875v-5.37c0-.339-.132-.664-.369-.906L11.22 7.88a1.267 1.267 0 0 0-.902-.379zm-2.94 1h2.94-.002c.072 0 .14.029.19.08l3.412 3.47a.293.293 0 0 1 .083.204v5.371c0 .488-.376.875-.842.875H7.344c-.467 0-.844-.387-.844-.875v-8.25a.883.883 0 0 1 .878-.875z" />
                                                    <path d="M10.25 7.5a.5.5 0 0 1 .5.49v3.389c.008.201.17.363.371.37l.009.001h3.37a.5.5 0 0 1 .5.49v.01a.5.5 0 0 1-.49.5H11.119a1.386 1.386 0 0 1-1.369-1.347V8a.5.5 0 0 1 .5-.5z" />
                                                    <path d="M13.813 4.5c.334 0 .655.132.894.367l.012.012 3.41 3.468c.234.237.366.554.37.885l.001.018v5.375c0 1.024-.802 1.858-1.812 1.875H14.75v-1h1.908c.46 0 .834-.38.842-.86V9.25a.285.285 0 0 0-.076-.194l-.007-.007-3.41-3.467a.276.276 0 0 0-.185-.082h-2.944a.883.883 0 0 0-.878.86V8H9V6.372A1.884 1.884 0 0 1 10.844 4.5H13.813z" />
                                                    <path d="M13.75 4.5a.5.5 0 0 1 .5.49V8.38c.008.201.17.363.371.37l.009.001H18a.5.5 0 0 1 .5.49v.01a.5.5 0 0 1-.49.5H14.619a1.386 1.386 0 0 1-1.369-1.347V5a.5.5 0 0 1 .5-.5z" />
                                                </g>
                                            </svg>
                                        </div>
                                        <p className={styles.smallFont + ' m-0'}>{file_meta?.metadata_page_count} pages</p>
                                    </div>
                                )}
                            </div>
                            <div className={styles.smallLabelBox}>
                                <p className={styles.smallBlueLabel + ' mb-1'}>Added By</p>
                                <div>{getUserDetail(doc?.upload_by)}</div>
                                <p className={styles.smallFont + ' m-0'}>
                                    {doc?.created && format(new Date(doc?.created), 'dd/MM/yyyy')} &nbsp;
                                    {doc?.created && <span style={{ color: 'var(--muted)' }}>{doc?.created && formatDateDifferenc(doc?.created)}</span>}
                                </p>
                            </div>
                            {file_meta?.metadata_author && (
                                <div className={styles.smallLabelBox}>
                                    <p className={styles.smallBlueLabel + ' mb-1'}>Author</p>
                                    <div className={styles.smallFont + ' m-0'}>{file_meta?.metadata_author}</div>
                                    {/* <p className={styles.smallFont + ' m-0'}>Hard Coded Text</p> */}
                                </div>
                            )}

                            <div className="mt-5 d-flex  justify-content-between">
                                <div>
                                    {(isProjectAdmin || doc?.can_download_original || doc?.can_download_watermarked) && (
                                        <p onClick={() => handleDownloadFile(doc)} className={styles.orangeLink}>
                                            Download
                                        </p>
                                    )}

                                    {/* {(isProjectAdmin || checkPermission('file', doc?.id, 'delete', selectedFolder?.id)) && (
                                     
                                    )} */}
                                    <DoubleConfirmationModal
                                        handleAction={() => handleDeleteFile(doc?.id)}
                                        message="Deleting a File will permanently remove it from the Data Room.">
                                        <p className={styles.orangeLink + ' mb-0'}>Delete {deleteBtnLoading && <AiOutlineLoading3Quarters className="rotateLoader" />}</p>
                                    </DoubleConfirmationModal>
                                </div>
                                <button onClick={() => setShowModal(false)} className={'btn btn-primary btn-sm ' + styles.smallButton}>
                                    Close
                                </button>
                            </div>
                        </div>
                        <div style={{ visibility: 'hidden', height: 0 }} className={'webviewer'} ref={viewer}></div>
                    </Offcanvas.Body>
                </Offcanvas>
            )}
        </>
    );
};
const AddWorkstreamModal = ({ showModal, setShowModal }) => {
    const dispatch = useDispatch();
    const [workstream, setWorkstream] = React.useState();
    const { workstreams, addWsLoading, default_workstreams } = useSelector(state => state?.dataroom);
    const { selectedProject } = useSelector(state => state?.projectData);
    const handleClose = () => {
        setShowModal(false);
        setWorkstream('');
    };
    const handleSubmit = async e => {
        e.preventDefault();
        await dispatch(PostWorkstream({ name: workstream, project: selectedProject?.id, vdr: selectedProject?.vdr?.id }));
        setWorkstream('');
    };

    return (
        <>
            <Offcanvas placement="end" show={showModal} onHide={handleClose}>
                <Offcanvas.Body className={styles.sidebarBody}>
                    <div className="d-flex justify-content-between">
                        <div>
                            <svg width="24" height="23" viewBox="0 0 24 23" xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M21.203 18.215h1.376v-1.38h-1.376v1.38zm-.006-5.911h1.377v-1.378h-1.377v1.378zm-.001-5.907h1.377V5.021h-1.377v1.376zM8.845 5.721c.535-.052 1.54-.12 2.534-.259 1.007-.14 1.992-.397 2.895-.881.298-.16.58-.37.828-.6.306-.287.3-.554-.001-.85a3.334 3.334 0 0 0-.667-.509c-.813-.47-1.708-.716-2.622-.894-1.774-.345-3.564-.4-5.361-.226-1.144.112-2.27.32-3.348.737-.519.202-1.021.435-1.424.832-.362.356-.365.625.006.975.174.165.37.315.58.43.307.168.626.32.954.44 1.663.612 3.399.769 5.626.805zm6.482-.09c-2.206 1.184-4.564 1.476-6.97 1.477-2.405 0-4.759-.303-6.948-1.47v.254c0 .874.013 1.748-.007 2.623-.008.341.12.589.365.793.15.124.302.26.477.335.586.25 1.168.528 1.778.701 1.813.515 3.674.604 5.546.5 1.367-.078 2.721-.265 4.002-.776.48-.19.93-.466 1.37-.742.283-.177.402-.463.394-.822-.021-.874-.007-1.749-.007-2.623v-.25zM1.409 16.015c0 .955.021 1.877-.01 2.797-.014.447.17.743.503.99.482.358 1.027.586 1.592.773 1.323.437 2.689.619 4.075.67 1.978.072 3.932-.079 5.822-.721.593-.202 1.165-.451 1.635-.885a.868.868 0 0 0 .306-.702c-.016-.577-.005-1.156-.005-1.734v-1.186c-2.194 1.17-4.548 1.465-6.955 1.466-2.407 0-4.762-.296-6.963-1.468zm0-5.2c0 .944.027 1.859-.011 2.77-.021.508.177.86.583 1.084.502.277 1.018.55 1.559.733 1.546.522 3.153.675 4.777.677 1.703.003 3.382-.165 5.008-.71.579-.194 1.136-.435 1.614-.83.26-.214.41-.467.394-.827-.023-.546-.006-1.093-.006-1.64v-1.257c-2.193 1.17-4.547 1.465-6.954 1.466-2.408.001-4.762-.297-6.964-1.466zM0 19.35V3.274c.188-.787.693-1.331 1.362-1.735a7.784 7.784 0 0 1 1.02-.52C3.756.444 5.206.192 6.682.074c2.19-.175 4.355-.048 6.48.533.968.265 1.898.626 2.684 1.279.59.491.925 1.104.889 1.896-.019.403-.003.807-.003 1.21h3.048v-.624c.005-.472.289-.763.757-.764a452.89 452.89 0 0 1 2.695 0c.473.001.764.287.765.755.004.899.003 1.797.001 2.695-.001.482-.291.766-.779.767-.89.002-1.78.002-2.67 0-.483-.001-.766-.29-.769-.778v-.614h-3.03v4.28h3.03v-.418c.003-.5.285-.78.788-.781.89-.002 1.78-.003 2.67 0 .47 0 .758.29.76.762.003.898.003 1.796 0 2.695-.002.47-.292.758-.761.76-.899.002-1.797.003-2.696 0-.47-.002-.756-.291-.76-.76-.003-.272-.001-.543-.001-.818h-3.028v4.658h3.028c0-.221-.002-.431 0-.64.006-.457.293-.75.747-.751.906-.003 1.813-.003 2.718 0 .457.001.75.29.752.745.004.906.004 1.812 0 2.718-.001.457-.292.751-.744.753-.906.004-1.813.003-2.718 0-.467-.001-.751-.294-.754-.767-.002-.208-.001-.416-.001-.62h-3.046c0 .26-.008.502 0 .744a1.95 1.95 0 0 1-.57 1.487c-.26.265-.554.51-.87.704-1.192.732-2.527 1.052-3.89 1.265a19.91 19.91 0 0 1-5.021.133c-1.38-.135-2.739-.38-4.021-.93C1.288 21.185.292 20.625 0 19.35z"
                                    fill="#003149"
                                    fillRule="evenodd"
                                />
                            </svg>

                            <b className="ms-3">Add Workstream</b>
                        </div>
                        <IoIosClose onClick={handleClose} color="var(--Brand-Secondary)" size={20} />
                    </div>
                    <div className="mt-5">
                        <div className="mb-5">
                            {workstreams?.map(item => (
                                <div key={item?.id} className={styles.addWorkstreamList}>
                                    <span>{item?.name}</span>
                                    <span style={{ color: 'var(--success)' }}>Added</span>
                                </div>
                            ))}
                            {default_workstreams?.map(ws => {
                                let check = workstreams?.find(w => w?.name === ws.workstream);
                                if (!check) {
                                    return (
                                        <div key={ws?.id} className={styles.addWorkstreamList + ' create-workstream-step'}>
                                            <span style={{ color: 'var(--muted)' }}>{ws?.workstream}</span>
                                            <span
                                                onClick={() => dispatch(PostWorkstream({ name: ws?.workstream, project: selectedProject?.id, vdr: selectedProject?.vdr?.id }))}
                                                role="button"
                                                style={{ color: 'var(--danger)' }}>
                                                Add
                                            </span>
                                        </div>
                                    );
                                }
                            })}
                        </div>
                        <div>
                            <div className="mb-2">
                                <small htmlFor className="form-label mb-2 smallFont">
                                    Or add a Custom Workstream
                                </small>
                                <input
                                    className="form-control  mt-1 smallFont"
                                    placeholder="Type here"
                                    name="description"
                                    value={workstream}
                                    onChange={e => setWorkstream(e.target.value)}
                                />
                            </div>
                            <div className="d-flex justify-content-between align-items-center">
                                <button disabled={!workstream} onClick={handleSubmit} className={'btn btn-primary btn-sm mt-3 smallButton '}>
                                    Add {addWsLoading && <AiOutlineLoading3Quarters className="rotateLoader" />}
                                </button>
                                <span
                                    onClick={() => {
                                        handleClose();
                                        dispatch(setJoyRideStepIndex(4));
                                    }}
                                    className={styles.orangeLink + ' done-ws-modal-step'}>
                                    Done
                                </span>
                            </div>
                        </div>
                    </div>
                </Offcanvas.Body>
            </Offcanvas>
        </>
    );
};
const EditWorkstreamModal = ({ selected }) => {
    const [showModal, setShowModal] = React.useState(false);
    const dispatch = useDispatch();
    const [workstream, setWorkstream] = React.useState();
    const { addWsLoading } = useSelector(state => state?.dataroom);
    const handleClose = () => {
        setShowModal(false);
        setWorkstream('');
    };

    const handleSubmit = async e => {
        e.preventDefault();
        await dispatch(PatchWorkstream({ name: workstream, id: selected?.id, project: localStorage['project_id'] }));
        handleClose();
    };

    React.useEffect(() => {
        setWorkstream(selected?.name);
    }, [selected, showModal]);

    return (
        <>
            <div onClick={() => setShowModal(true)} className={styles.wsChipMenuItem} style={{ color: 'var(--primary)' }}>
                <FiEdit className="me-2" />
                Edit Workstream Label
            </div>
            <Offcanvas placement="end" show={showModal} onHide={handleClose}>
                <Offcanvas.Body className={styles.sidebarBody}>
                    <div className="d-flex justify-content-between">
                        <div>
                            <svg width="24" height="23" viewBox="0 0 24 23" xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M21.203 18.215h1.376v-1.38h-1.376v1.38zm-.006-5.911h1.377v-1.378h-1.377v1.378zm-.001-5.907h1.377V5.021h-1.377v1.376zM8.845 5.721c.535-.052 1.54-.12 2.534-.259 1.007-.14 1.992-.397 2.895-.881.298-.16.58-.37.828-.6.306-.287.3-.554-.001-.85a3.334 3.334 0 0 0-.667-.509c-.813-.47-1.708-.716-2.622-.894-1.774-.345-3.564-.4-5.361-.226-1.144.112-2.27.32-3.348.737-.519.202-1.021.435-1.424.832-.362.356-.365.625.006.975.174.165.37.315.58.43.307.168.626.32.954.44 1.663.612 3.399.769 5.626.805zm6.482-.09c-2.206 1.184-4.564 1.476-6.97 1.477-2.405 0-4.759-.303-6.948-1.47v.254c0 .874.013 1.748-.007 2.623-.008.341.12.589.365.793.15.124.302.26.477.335.586.25 1.168.528 1.778.701 1.813.515 3.674.604 5.546.5 1.367-.078 2.721-.265 4.002-.776.48-.19.93-.466 1.37-.742.283-.177.402-.463.394-.822-.021-.874-.007-1.749-.007-2.623v-.25zM1.409 16.015c0 .955.021 1.877-.01 2.797-.014.447.17.743.503.99.482.358 1.027.586 1.592.773 1.323.437 2.689.619 4.075.67 1.978.072 3.932-.079 5.822-.721.593-.202 1.165-.451 1.635-.885a.868.868 0 0 0 .306-.702c-.016-.577-.005-1.156-.005-1.734v-1.186c-2.194 1.17-4.548 1.465-6.955 1.466-2.407 0-4.762-.296-6.963-1.468zm0-5.2c0 .944.027 1.859-.011 2.77-.021.508.177.86.583 1.084.502.277 1.018.55 1.559.733 1.546.522 3.153.675 4.777.677 1.703.003 3.382-.165 5.008-.71.579-.194 1.136-.435 1.614-.83.26-.214.41-.467.394-.827-.023-.546-.006-1.093-.006-1.64v-1.257c-2.193 1.17-4.547 1.465-6.954 1.466-2.408.001-4.762-.297-6.964-1.466zM0 19.35V3.274c.188-.787.693-1.331 1.362-1.735a7.784 7.784 0 0 1 1.02-.52C3.756.444 5.206.192 6.682.074c2.19-.175 4.355-.048 6.48.533.968.265 1.898.626 2.684 1.279.59.491.925 1.104.889 1.896-.019.403-.003.807-.003 1.21h3.048v-.624c.005-.472.289-.763.757-.764a452.89 452.89 0 0 1 2.695 0c.473.001.764.287.765.755.004.899.003 1.797.001 2.695-.001.482-.291.766-.779.767-.89.002-1.78.002-2.67 0-.483-.001-.766-.29-.769-.778v-.614h-3.03v4.28h3.03v-.418c.003-.5.285-.78.788-.781.89-.002 1.78-.003 2.67 0 .47 0 .758.29.76.762.003.898.003 1.796 0 2.695-.002.47-.292.758-.761.76-.899.002-1.797.003-2.696 0-.47-.002-.756-.291-.76-.76-.003-.272-.001-.543-.001-.818h-3.028v4.658h3.028c0-.221-.002-.431 0-.64.006-.457.293-.75.747-.751.906-.003 1.813-.003 2.718 0 .457.001.75.29.752.745.004.906.004 1.812 0 2.718-.001.457-.292.751-.744.753-.906.004-1.813.003-2.718 0-.467-.001-.751-.294-.754-.767-.002-.208-.001-.416-.001-.62h-3.046c0 .26-.008.502 0 .744a1.95 1.95 0 0 1-.57 1.487c-.26.265-.554.51-.87.704-1.192.732-2.527 1.052-3.89 1.265a19.91 19.91 0 0 1-5.021.133c-1.38-.135-2.739-.38-4.021-.93C1.288 21.185.292 20.625 0 19.35z"
                                    fill="#003149"
                                    fillRule="evenodd"
                                />
                            </svg>

                            <b className="ms-3">Edit Workstream Label</b>
                        </div>
                        <IoIosClose onClick={handleClose} color="var(--Brand-Secondary)" size={20} />
                    </div>
                    <div className="mt-5">
                        <div>
                            <div className="mb-2">
                                <input
                                    className="form-control  mt-1 smallFont"
                                    placeholder="Type here"
                                    name="description"
                                    value={workstream}
                                    onChange={e => setWorkstream(e.target.value)}
                                />
                            </div>
                            <div className="d-flex justify-content-between align-items-center  mt-5">
                                <button onClick={handleSubmit} className={'btn btn-primary btn-sm smallButton '}>
                                    Save {addWsLoading && <AiOutlineLoading3Quarters className="rotateLoader" />}
                                </button>
                                <span onClick={handleClose} className={styles.orangeLink}>
                                    Cancel
                                </span>
                            </div>
                        </div>
                    </div>
                </Offcanvas.Body>
            </Offcanvas>
        </>
    );
};
const AddFolderModal = ({ showModal, setShowModal, workstream }) => {
    const dispatch = useDispatch();
    const { workstreams, default_folders, items, addAllFolderLoading } = useSelector(state => state?.dataroom);
    const [customViewModal, setCustomViewModal] = React.useState(false);

    // Check if all default folders are already added
    const allFoldersAdded = React.useMemo(() => {
        if (!default_folders || !items) return false;
        return default_folders.every(defaultFolder => items.some(existingFolder => existingFolder.name === defaultFolder.ws_folder));
    }, [default_folders, items]);

    // Count how many default folders are missing
    const missingFoldersCount = React.useMemo(() => {
        if (!default_folders || !items) return 0;
        return default_folders.filter(defaultFolder => !items.some(existingFolder => existingFolder.name === defaultFolder.ws_folder)).length;
    }, [default_folders, items]);

    const handleClose = () => {
        setShowModal(false);
    };
    const handleSubmit = async data => {
        let body = {
            name: data?.ws_folder,
            description: data?.ws_folder_desc,
            requested: true,
            workstream: workstream,
        };
        await dispatch(PostWSFolder(body));
        dispatch(setJoyRideStepIndex(6));
    };
    return (
        <>
            <Offcanvas placement="end" show={showModal} onHide={handleClose}>
                <Offcanvas.Body className={styles.sidebarBody}>
                    <div className="d-flex justify-content-between">
                        <div>
                            <h3>{workstreams?.find(item => workstream === item?.id)?.name}</h3>
                            <b className="">Add Folder</b>
                        </div>
                    </div>
                    <div className="mt-5">
                        <div className="mb-5 ">
                            {default_folders?.length > 0 &&
                                (allFoldersAdded ? (
                                    <p style={{ color: 'var(--Neutral-Gray-6)', cursor: 'default' }}>Add All Folders</p>
                                ) : (
                                    <p
                                        onClick={() => dispatch(PostAllWSFolders(workstream))}
                                        style={{
                                            color: 'var(--Brand-Secondary)',
                                            cursor: addAllFolderLoading ? 'not-allowed' : 'pointer',
                                        }}
                                        role="button">
                                        Add All Folders &nbsp; {addAllFolderLoading && <AiOutlineLoading3Quarters className="rotateLoader" />}
                                    </p>
                                ))}
                            <div className="create-folder-step">
                                {items?.map(item => (
                                    <div key={item?.id} className={styles.addWorkstreamList}>
                                        <span className="d-flex align-items-center">
                                            <div className={styles?.dropdown}>
                                                <AiOutlineInfoCircle size={16} className="me-2" role="button" />
                                                <div className={styles.hoverMenuContent}>
                                                    <div
                                                        style={{
                                                            width: '224px',
                                                            top: 20,
                                                            left: 0,
                                                        }}
                                                        className={styles.hoverMenuCont}>
                                                        {item?.description}
                                                    </div>
                                                </div>
                                            </div>
                                            {item?.name}
                                        </span>
                                        <span onClick={() => dispatch(setJoyRideStepIndex(6))} style={{ color: 'var(--success)' }}>
                                            Added
                                        </span>
                                    </div>
                                ))}

                                {default_folders?.map(item => {
                                    let check = items?.find(folder => folder?.name === item?.ws_folder);
                                    if (!check) {
                                        return (
                                            <div key={item?.id} className={styles.addWorkstreamList}>
                                                <span style={{ color: 'var(--muted)' }} className="d-flex align-items-center">
                                                    <div className={styles?.dropdown}>
                                                        <AiOutlineInfoCircle size={16} className="me-2" role="button" />
                                                        <div className={styles.hoverMenuContent}>
                                                            <div
                                                                style={{
                                                                    width: '300px',
                                                                    top: 20,
                                                                    left: 0,
                                                                }}
                                                                className={styles.hoverMenuCont}>
                                                                {item?.ws_folder_desc}
                                                            </div>
                                                        </div>
                                                    </div>

                                                    {item?.ws_folder}
                                                </span>
                                                <span style={{ color: 'var(--danger)' }} onClick={() => handleSubmit(item)} role="button">
                                                    Add
                                                </span>
                                            </div>
                                        );
                                    }
                                })}
                            </div>
                        </div>

                        <p onClick={() => setCustomViewModal(true)} style={{ color: 'var(--Brand-Secondary)' }} role="button">
                            Add Custom Folder
                        </p>

                        <button
                            className={'btn btn-primary btn-sm mt-3 smallButton done-add-folder-step'}
                            onClick={() => {
                                handleClose();
                                dispatch(setJoyRideStepIndex(7));
                            }}>
                            Done
                        </button>
                    </div>
                </Offcanvas.Body>
            </Offcanvas>
            <AddCustomFolder customViewModal={customViewModal} setCustomViewModal={setCustomViewModal} workstream={workstream} />
        </>
    );
};
const AddCustomFolder = ({ customViewModal, setCustomViewModal, workstream }) => {
    const dispatch = useDispatch();
    const { workstreams, folderBtnLoading } = useSelector(state => state?.dataroom);
    const [formData, setFormData] = React.useState({
        category: '',
        description: '',
    });
    const handleClose = () => {
        setCustomViewModal(false);
        setFormData({ category: '', description: '' });
    };

    const handleSubmit = async e => {
        let body = {
            name: formData?.category,
            description: formData?.description,
            requested: true,
            workstream,
        };
        await dispatch(PostWSFolder(body));
        setCustomViewModal(false);
        setFormData({
            category: '',
            description: '',
        });
    };
    return (
        <>
            <Offcanvas placement="end" show={customViewModal} onHide={handleClose}>
                <Offcanvas.Body className={styles.sidebarBody}>
                    <div className="d-flex justify-content-between">
                        <div>
                            <h3>{workstreams?.find(item => workstream === item?.id)?.name}</h3>
                            <b className="">Add Folder</b>
                        </div>
                    </div>

                    <div className="mt-5">
                        <div className="d-flex justify-content-between align-items-center">
                            <p className="m-0 smallFont">Add Custom Folder Name</p>
                        </div>
                        <div className="mt-1 mb-4">
                            <input
                                type="text"
                                name="category"
                                placeholder="Type here"
                                value={formData?.category}
                                onChange={e =>
                                    setFormData({
                                        ...formData,
                                        category: e.target.value,
                                    })
                                }
                                className="form-control commonInput"
                            />
                        </div>
                        <div className="mb-5">
                            <label htmlFor className="form-label mb-1 smallFont">
                                Add Folder Description
                            </label>
                            <input
                                type="text"
                                className="form-control commonInput"
                                name="description"
                                placeholder="Type here"
                                value={formData?.description}
                                onChange={e =>
                                    setFormData({
                                        ...formData,
                                        description: e.target.value,
                                    })
                                }
                            />
                        </div>
                        <div className="d-flex justify-content-between align-items-center">
                            <button disabled={!formData?.category || !formData?.description} onClick={handleSubmit} className="btn btn-primary smallButton">
                                &nbsp; Add &nbsp; {folderBtnLoading && <AiOutlineLoading3Quarters className="rotateLoader" />}
                            </button>
                            <b onClick={handleClose} className={styles.orangeLink}>
                                Back
                            </b>
                        </div>
                    </div>
                </Offcanvas.Body>
            </Offcanvas>
        </>
    );
};
const EditCustomFolder = ({ workstream, selectedFolder, setSelectedFolder }) => {
    const dispatch = useDispatch();
    const { workstreams, folderBtnLoading } = useSelector(state => state?.dataroom);
    const [modalVisible, setModalVisible] = React.useState(false);
    const [formData, setFormData] = React.useState({
        category: '',
        description: '',
    });
    const handleClose = () => {
        setModalVisible(false);
        setFormData({ category: '', description: '' });
    };
    const handleSubmit = async e => {
        let body = {
            name: formData?.category,
            description: formData?.description,
            workstream,
            id: selectedFolder?.id,
        };
        let res = await dispatch(PatchWSFolder(body));
        if (res?.type === 'PATCH_IRL_ITEMS/fulfilled') setSelectedFolder(res?.payload?.data);
        setModalVisible(false);
    };

    React.useEffect(() => {
        setFormData({
            category: selectedFolder?.name,
            description: selectedFolder?.description,
        });
    }, [selectedFolder]);
    return (
        <>
            <div
                onClick={() => {
                    setModalVisible(true);
                }}
                className={styles.wsChipMenuItem}>
                <FiEdit className="me-2" />
                Edit Workstream Folder
            </div>
            <Offcanvas placement="end" show={modalVisible} onHide={handleClose}>
                <Offcanvas.Body className={styles.sidebarBody}>
                    <div className="d-flex justify-content-between">
                        <div>
                            <h3>{workstreams?.find(item => workstream === item?.id)?.name}</h3>
                            <b className="">Edit Folder</b>
                        </div>
                    </div>

                    <div className="mt-5">
                        <div className="d-flex justify-content-between align-items-center">
                            <p className="m-0 smallFont">Folder Name</p>
                        </div>
                        <div className="mt-1 mb-4">
                            <input
                                type="text"
                                name="category"
                                placeholder="Type here"
                                value={formData?.category}
                                onChange={e =>
                                    setFormData({
                                        ...formData,
                                        category: e.target.value,
                                    })
                                }
                                className="form-control commonInput"
                            />
                        </div>
                        <div className="mb-5">
                            <label htmlFor className="form-label mb-1 smallFont">
                                Folder Description
                            </label>
                            <textarea
                                rows={3}
                                type="text"
                                className="form-control commonInput"
                                name="description"
                                placeholder="Type here"
                                value={formData?.description}
                                onChange={e =>
                                    setFormData({
                                        ...formData,
                                        description: e.target.value,
                                    })
                                }
                            />
                        </div>
                        <div className="d-flex justify-content-between align-items-center">
                            <button onClick={handleSubmit} className="btn btn-primary smallButton">
                                Save &nbsp; {folderBtnLoading && <AiOutlineLoading3Quarters className="rotateLoader" />}
                            </button>
                            <b onClick={handleClose} className={styles.orangeLink}>
                                Cancel
                            </b>
                        </div>
                    </div>
                </Offcanvas.Body>
            </Offcanvas>
        </>
    );
};

export default Main;
